<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:55%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["BAL"][obj_bankacc.I > 0? "EBA": "ABA"]}}</h4>
                                    </CCol>
                                    <CCol col="4">

                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeAdd()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["DM"]["AGI"]}}<span class="required" /> :</label>
                                            <customtreeselect :multiple="false"
                                                              :options="dd_agentgroup"
                                                              :flat="true"
                                                              :defaultExpandLevel="Infinity"
                                                              :clearable="false"
                                                              :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                              @input="AgentGroupChange"
                                                              v-model="obj_bankacc['AGIT']"
                                                              :disabled="obj_bankacc.I > 0"
                                                              ref="AGIT" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('AGIT','AGI') }}</span>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{getLanguage["BAL"]["S"]}} :</label><br>
                                            <label class="switch">
                                                <input type="checkbox" :checked="bool_obj_bankaccRS" @change="v => bool_obj_bankaccRS = v.target.checked" >
                                                <span class="slider round" ></span>
                                            </label>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["BAL"]["CC"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_cc"
                                                        :clearable="false"
                                                        v-model="obj_bankacc['CC']"
                                                        :flat="true"
                                                        :defaultExpandLevel="Infinity"
                                                        @input="CountryCodeChange"
                                                        :disabled="obj_bankacc.I > 0"
                                                        ref="CC" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('CC','CC') }}</span>

                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm"> {{getLanguage["BAL"]["BN"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_bank"
                                                        @input="BankChange"
                                                        v-model="obj_bankacc['BI']"
                                                        :disabled="obj_bankacc.I > 0"
                                                        ref="BI" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('BI','BN') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm"> {{getLanguage["BAL"]["AT"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="arry_accType"
                                                        :clearable="false"
                                                        @input="setAT_add"
                                                        v-model="obj_bankacc['AT']"
                                                        ref="AT" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('AT','AT') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="2">
                                            <label class="col-form-label-sm"> {{getLanguage["BAL"]["C"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        @input="CurrencyChange"
                                                        v-model="obj_bankacc['CI']"
                                                        :options="dd_currency"
                                                        :disabled="obj_bankacc.I > 0"
                                                        ref="CI" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('CI','C') }}</span>
                                        </CCol>
                                        <CCol col="4">
                                            <label class="col-form-label-sm">{{getLanguage["BAL"]["DC"]}} :</label><br>
                                            <label class="switch">
                                                <input type="checkbox" :checked="bool_obj_bankaccDC" @change="v => bool_obj_bankaccDC = v.target.checked">
                                                <span class="slider round"></span>
                                            </label>
                                        </CCol>
                                        <CCol col="6" v-show="bool_obj_bankaccDC">
                                            <div style="display: grid; gap: 5px; grid-template-columns: 1fr .1fr 1fr;">
                                                <div>
                                                    <label class='col-form-label-sm'>{{ this.getLanguage['PM']['F'] }} (Currency/Amount)<span class="required" /> :</label>
                                                    <div style=" display: grid; grid-template-columns: 2.5fr 4fr;">
                                                        <div>
                                                            <CInput size="sm"
                                                                    vertical
                                                                    :value="(bool_obj_bankaccDC ? obj_bankacc.FCS : '').toUpperCase()"
                                                                    @change="v => obj_bankacc.FCS = v"
                                                                    :disabled="obj_bankacc.FCS == currencySymbol"
                                                                    ref="FCS" />
                                                            <span class="ErrMsg">{{ ValidationErrMsg('FCS','AC') }}</span>
                                                        </div>
                                                        <div>
                                                            <CInput size="sm"
                                                                    vertical
                                                                    :value="bool_obj_bankaccDC ? obj_bankacc.ER : ''"
                                                                    @change="v => obj_bankacc.ER = v"
                                                                    :disabled="obj_bankacc.ER === 1"
                                                                    ref="ER" />
                                                            <span class="ErrMsg">{{ ValidationErrMsg('ER','ER') }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="text-center">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 17" aria-hidden="true" width="20" height="20" style="margin-top: 30px; background: #ebedef; padding: 4px; border-radius: 50%; border: solid 1px #d8dbe0; box-shadow: 1px 1px #313030;cursor:pointer" @click="switchCurrencySymbol();" v-show="obj_bankacc.FCS && obj_bankacc.TCS">
                                                        <path fill="currentColor" fill-rule="evenodd" d="M11.726 1.273l2.387 2.394H.667V5h13.446l-2.386 2.393.94.94 4-4-4-4-.94.94zM.666 12.333l4 4 .94-.94L3.22 13h13.447v-1.333H3.22l2.386-2.394-.94-.94-4 4z" clip-rule="evenodd"></path>
                                                    </svg>
                                                </div>
                                                <div>
                                                    <label class='col-form-label-sm'>{{ this.getLanguage['PM']['T'] }} (Currency/Amount)<span class="required" /> :</label>
                                                    <div style=" display: grid; grid-template-columns: 2.5fr 4fr;">
                                                        <div>
                                                            <CInput size="sm"
                                                                    vertical
                                                                    :value="(bool_obj_bankaccDC ? obj_bankacc.TCS : '').toUpperCase()"
                                                                    @change="v => obj_bankacc.TCS = v"
                                                                    :disabled="obj_bankacc.TCS == currencySymbol"
                                                                    ref="TCS" />
                                                            <span class="ErrMsg">{{ ValidationErrMsg('TCS','AC') }}</span>
                                                        </div>
                                                        <div>
                                                            <CInput size="sm"
                                                                    vertical
                                                                    :value="bool_obj_bankaccDC ? obj_bankacc.TER : ''"
                                                                    :placeholder="this.getLanguage['PM']['A']"
                                                                    @change="v => obj_bankacc.TER = v"
                                                                    ref="TER" />
                                                            <span class="ErrMsg">{{ ValidationErrMsg('TER','ER') }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm"> {{getLanguage["BAL"]["BANM"]}}<span class="required" /> :</label>
                                            <CInput vertical
                                                    size="sm"
                                                    :value="obj_bankacc.BA"
                                                    @change="v => obj_bankacc.BA = v"
                                                    :disabled="obj_bankacc.I > 0"
                                                    ref="BA" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('BA','BANM') }}</span>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm"> {{getLanguage["BAL"]["BANO"]}}<span class="required" /> :</label>
                                            <CInput vertical
                                                    size="sm"
                                                    :value="obj_bankacc.BAN"
                                                    @change="v => obj_bankacc.BAN = v"
                                                    :disabled="obj_bankacc.I > 0"
                                                    ref="BAN" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('BAN','BANO') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6" class="my-2" v-if="obj_bankacc.AT != 0 ">
                                            <label class="col-form-label-sm">{{this.getLanguage["MDB"]["PM"]}} :</label>
                                            <treeselect :multiple="true"
                                                        :options="dd_pm"
                                                        :flat="true"
                                                        :defaultExpandLevel="Infinity"
                                                        :clearable="false"
                                                        :placeholder="this.utilGetDDLanguage('MDB.PM')"
                                                        v-model="obj_bankacc['PM']"
                                                        ref="PM" />
                                        </CCol>
                                        <CCol col="6" class="my-2">
                                            <label class="col-form-label-sm">{{this.getLanguage["MDB"]["PLURL"]}} :</label>
                                            <div class="custom_tooltip">
                                                <i class="fa fa-question-circle"></i>
                                                <span class="tooltiptext2" style=" width: 190px !important; right: -700% !important; margin-right: -800% !important;">{{getLanguage["HELP"]["PLURL"]}}</span>
                                            </div>
                                            <CInput vertical
                                                    size="sm"
                                                    :value="obj_bankacc.PLURL"
                                                    @change="v => obj_bankacc.PLURL = v"
                                                    :disabled="bool_isDisablePLURL"
                                                    ref="PLURL" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('PLURL','IURLF') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{getLanguage["BAL"]["VIP"]}} :</label><br>
                                            <label class="switch">
                                                <input type="checkbox" :checked="obj_bankacc.VIPBA" v-model="obj_bankacc.VIPBA" />
                                                <span class="slider round"></span>
                                            </label>
                                        </CCol>
                                        <CCol col="6" class="form-group" v-show="obj_bankacc.VIPBA">
                                            <label class='col-form-label-sm'>{{this.getLanguage['MEM']['MTI']}}<span class="required" /> :</label>
                                            <treeselect :multiple="true"
                                                        :options="ddEditMemberTypeList"
                                                        :defaultExpandLevel="1"
                                                        valueConsistsOf="LEAF_PRIORITY"
                                                        :placeholder="this.utilGetDDLanguage('MEM.MTI')"
                                                        v-model="obj_bankacc.MTV" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('MTV','MTI') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="bool_isD">
                                        <CCol>
                                            <label class="col-form-label-sm">{{getLanguage["BANK"]["MIND"]}} : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                            <CInput size="sm" :prepend="currencySymbol" vertical :value="ThousandSeparator(obj_bankacc.MIND, getThousandCurrency ? 3 : 2)" :placeholder="getLanguage['BANK']['MIND']" @change="v => obj_bankacc.MIND = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"></CInput>
                                        </CCol>
                                        <CCol>
                                            <label class="col-form-label-sm">{{getLanguage["BANK"]["MAXD"]}} : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                            <CInput size="sm" :prepend="currencySymbol" vertical :value="ThousandSeparator(obj_bankacc.MAXD, getThousandCurrency ? 3 : 2)" :placeholder="getLanguage['BANK']['MAXD']" @change="v => obj_bankacc.MAXD = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"></CInput>
                                            <span class="ErrMsg">{{ checkMinMax(1) }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="bool_isD">
                                        <CCol>
                                            <label class="col-form-label-sm">{{getLanguage["BANK"][obj_bankacc.AT == 2?"TDTL":"MAXDACCT"]}}:<span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                            <label class="col-form-label-sm d-flex" style="gap:5px;"><input type="checkbox" style="margin-left:5px;" :true-value="1" :false-value="0" v-model="obj_bankacc.ISDL" />  {{this.getLanguage['BANK']['EDDLMS']}} </label>
                                            <CInput size="sm" :prepend="currencySymbol" vertical :value="ThousandSeparator(obj_bankacc.TD, getThousandCurrency ? 3 : 2)" :placeholder="getLanguage['BANK']['MAXDACCT']" @change="v => obj_bankacc.TD = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"></CInput>
                                        </CCol>
                                        <CCol>
                                            <label class="col-form-label-sm">{{getLanguage["BANK"][obj_bankacc.AT == 2?"ADWA":"ADEPAMT"]}} : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                            <CButton size="sm" color="outline-info" style="float: right;" @click="confirmreset(obj_bankacc.I, obj_bankacc.TUD, obj_bankacc.AGI)">{{this.getLanguage["BTN"]["RS"]}}</CButton>
                                            <CInput size="sm" :prepend="currencySymbol" vertical :value="ThousandSeparator(obj_bankacc.TUD, getThousandCurrency ? 3 : 2)" :placeholder="getLanguage['BANK']['ADEPAMT']" :disabled="obj_bankacc.BA != null" @change="v => obj_bankacc.TUD = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"></CInput>
                                            <span class="ErrMsg">{{ checkMinMax(1) }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="bool_isW">
                                        <CCol>
                                            <label class="col-form-label-sm">{{getLanguage["BANK"]["MINW"]}} : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                            <CInput size="sm" :prepend="currencySymbol" vertical :value="ThousandSeparator(obj_bankacc.MINW, getThousandCurrency ? 3 : 2)" :placeholder="getLanguage['BANK']['MINW']" @change="v => obj_bankacc.MINW = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"></CInput>
                                        </CCol>
                                        <CCol>
                                            <label class="col-form-label-sm">{{getLanguage["BANK"]["MAXW"]}} : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                            <CInput size="sm" :prepend="currencySymbol" vertical :value="ThousandSeparator(obj_bankacc.MAXW, getThousandCurrency ? 3 : 2)" :placeholder="getLanguage['BANK']['MAXW']" @change="v => obj_bankacc.MAXW = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"></CInput>
                                            <span class="ErrMsg">{{ checkMinMax(2) }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <!-- <CCol col="6" v-if="bool_isD">
                                              <CInput size="sm"  :label="this.getLanguage['BANK']['TD']" vertical v-model="obj_bankacc['TD']"></CInput>
                                        </CCol> -->
                                        <CCol col="6" v-if="bool_isW">
                                            <label class="col-form-label-sm">{{getLanguage["BANK"]["TW"]}} : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                            <CInput size="sm" :prepend="currencySymbol" vertical :value="ThousandSeparator(obj_bankacc.TW, getThousandCurrency ? 3 : 2)" :placeholder="getLanguage['BANK']['TW']" @change="v => obj_bankacc.TW = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"></CInput>
                                        </CCol>
                                    </CRow>
                                    <div v-if="bool_isAutoDepositBank > 0 && bool_isAutoDepositBank <= 3" class="sectionDivider subHeaderHR"></div>
                                    <CRow v-if="bool_isAutoDepositBank > 0 && bool_isAutoDepositBank <= 3">
                                        <CCol col="12">
                                            <h6 class="card-title section-title" style="display:inline-block;">
                                                {{getLanguage["BANK"]["AD"]}}
                                            </h6>
                                            <!--<label class="switch">
                                                <input type="checkbox" :checked="bool_obj_isAutoDeposit" @change="isAutoDepositChange">
                                                <span class="slider round"></span>
                                            </label>-->
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="bool_isAutoDepositBank > 0 && bool_isAutoDepositBank <= 3">
                                        <CCol col="6">
                                            <label class="col-form-label-sm" style="display:block">
                                                {{getLanguage["BANK"]["ADTY"]}} :
                                                <div class="custom_tooltip" style="float:right">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="tooltiptext2 time-claim">{{getLanguage["HELP"]["ADTY"]}}</span>
                                                </div>
                                            </label>
                                            <treeselect :multiple="false"
                                                        :options="dd_adty"
                                                        :flat="true"
                                                        :defaultExpandLevel="Infinity"
                                                        @input="isAutoDepositChange"
                                                        v-model="obj_bankacc['IA']" />
                                            <label class="col-form-label-sm" style="display:block">
                                                {{getLanguage['BANK']['HBI']}} :
                                                <div class="custom_tooltip" style="float:right">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="tooltiptext2 time-claim">{{getLanguage["HELP"]["HBI"]}}</span>
                                                </div>
                                            </label>
                                            <label class="switch">
                                                <input type="checkbox" :checked="obj_bankacc.HBI" @change="v => obj_bankacc.HBI = v.target.checked">
                                                <span class="slider round"></span>
                                            </label>
                                        </CCol>
                                        <CCol col="6" v-if="bool_obj_isAutoDeposit == 1 || bool_obj_isAutoDeposit == 2">
                                            <label class="col-form-label-sm">{{getLanguage["BAL"]["IBU"]}} :</label>
                                            <CInput vertical size="sm" :value="obj_bankacc.BU" :placeholder="getLanguage['BANK']['IBU']" @change="v => obj_bankacc.BU = v" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('BU', 'IBU') }}</span>
                                        </CCol>
                                        <CCol col="6" v-if="bool_obj_isAutoDeposit == 11 || bool_obj_isAutoDeposit == 12">
                                            <label class="col-form-label-sm" style="display: block;">&nbsp;</label>
                                            <CButton color="outline-info" size="sm" @click="setupAutoDepositAPP()">
                                                <span class='plusIcon cil-plus'></span>
                                                {{this.getLanguage["BAL"]["ADSACC"]}}
                                            </CButton>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="bool_isAutoDepositBank > 0 && bool_isAutoDepositBank <= 3 && (bool_obj_isAutoDeposit == 1 || bool_obj_isAutoDeposit == 2)">
                                        <CCol col="6">
                                            <label class="col-form-label-sm full-width">
                                                {{getLanguage["BAL"]["IBP"]}} :
                                                <span v-if="obj_bankacc.LPUTS != null && !isEmptyDate(obj_bankacc.LPUTS)" class="float-right label-tooltip">{{getLanguage["BAL"]["LU"]}} : {{ formatDateTime(obj_bankacc.LPUTS) }}</span>
                                            </label>
                                            <CInput type="password" vertical size="sm" :value="obj_bankacc.BP" :placeholder="getLanguage['BANK']['IBP']" @change="v => obj_bankacc.BP = v" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('BP', 'IBP') }}</span>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{getLanguage["BAL"]["IBPC"]}} :</label>
                                            <CInput type="password"
                                                    vertical size="sm"
                                                    :value="obj_bankacc.BPC"
                                                    :placeholder="getLanguage['BANK']['IBPC']"
                                                    @change="v => obj_bankacc.BPC = v"
                                                    ref="BPC" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('BPC', 'IBPC') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="bool_isAutoDepositBank > 0 && bool_obj_isAutoDeposit==2">
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{getLanguage["BAL"]["ADS"]}} :</label>
                                            <CInput vertical size="sm" :value="obj_bankacc.ADS" :placeholder="getLanguage['BANK']['ADS']" @change="v => obj_bankacc.ADS = v" />
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{getLanguage["BAL"]["ADR"]}} :</label>
                                            <div class="custom_tooltip" v-on:click="copyLink()">
                                                <i class="fa fa-question-circle"></i>
                                                <span class="tooltiptext2 time-claim">{{getLanguage["BAL"]["ADRQ1"]}}</span><br />
                                                <span class="tooltiptext2 time-claim">{{getLanguage["BAL"]["ADRQ2"]}}</span>
                                            </div>
                                            <CInput vertical size="sm" :value="obj_bankacc.ADR" :placeholder="getLanguage['BANK']['ADR']" @change="v => obj_bankacc.ADR = v" />
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="bool_obj_bankaccRS & bool_isAutoDepositBank > 0 && bool_isAutoDepositBank <= 3 && (bool_obj_isAutoDeposit == 1 || bool_obj_isAutoDeposit == 2)">
                                        <CCol col="12">
                                            <label class="col-form-label-sm mandatory_Field">{{ getLanguage["BAL"]["TIP"] }}</label>
                                        </CCol>
                                    </CRow>
                                    <!-- SCB APP auto deposit -->
                                    <CRow v-if="bool_isAutoDepositBank > 0 && bool_isAutoDepositBank <= 3 && (bool_obj_isAutoDeposit == 11 || bool_obj_isAutoDeposit == 12)">
                                        <CCol col="6">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BCT']}} :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_adbct"
                                                        :flat="true"
                                                        :defaultExpandLevel="Infinity"
                                                        :disabled="true"
                                                        v-model="obj_bankacc['BCT']" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('BCT', 'BCT') }}</span>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BICN']}} :</label>
                                            <CInput vertical size="sm" :value="obj_bankacc.BICN" :placeholder="getLanguage['BAL']['BICN']" :readonly="true" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('BICN', 'BICN') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="bool_isAutoDepositBank > 0 && bool_isAutoDepositBank <= 3 && (bool_obj_isAutoDeposit == 11 || bool_obj_isAutoDeposit == 12)">
                                        <CCol col="6">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BDOB']}} :</label>
                                            <CInput vertical size="sm" :value="getADDOB()" :placeholder="getLanguage['BAL']['BDOB']" :readonly="true" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('BDOB', 'BDOB') }}</span>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BMN']}} :</label>
                                            <CInput vertical size="sm" :value="obj_bankacc.BMN" :placeholder="getLanguage['BAL']['BMN']" :readonly="true" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('BMN', 'BMN') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="bool_isAutoDepositBank > 0 && bool_isAutoDepositBank <= 3 && (bool_obj_isAutoDeposit == 11 || bool_obj_isAutoDeposit == 12)">
                                        <CCol col="6">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BAPIN']}} :</label>
                                            <CInput type="password" vertical size="sm" :value="obj_bankacc.BAPIN" :placeholder="getLanguage['BAL']['BAPIN']" :readonly="true" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('BAPIN', 'BAPIN') }}</span>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BDI']}} :</label>
                                            <CInput vertical size="sm" :value="obj_bankacc.BDI" :placeholder="getLanguage['BAL']['BDI']" :readonly="true" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('BDI', 'BDI') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="bool_obj_bankaccRS & bool_isAutoDepositBank > 0 && bool_isAutoDepositBank <= 3 && (bool_obj_isAutoDeposit == 11 || bool_obj_isAutoDeposit == 12)">
                                        <CCol col="12">
                                            <label class="col-form-label-sm mandatory_Field">{{ getLanguage["BAL"]["ADTIP"] }}</label>
                                        </CCol>
                                    </CRow>

                                    <!-- Auto Withdrawal start -->

                                    <div v-if="bool_isAutoDepositBank > 0 && bool_isAutoDepositBank <= 3 && (bool_obj_isAutoDeposit == 11 || bool_obj_isAutoDeposit == 12) && obj_bankacc.AT == 2 && getUserInfo.AT == 0" class="sectionDivider subHeaderHR"></div>
                                    <CRow v-if="bool_isAutoDepositBank > 0 && bool_isAutoDepositBank <= 3 && (bool_obj_isAutoDeposit == 11 || bool_obj_isAutoDeposit == 12)&& obj_bankacc.AT == 2 && getUserInfo.AT == 0">
                                        <CCol col="6">
                                            <h6 class="card-title section-title" style="display:inline-block;">
                                                {{getLanguage['BAL']['AW']}}
                                            </h6>

                                            <div class="custom_tooltip ml-2">
                                                <i class="fa fa-question-circle"></i>
                                                <span class="tooltiptext2" style="white-space: pre-line;  ">{{getLanguage["HELP"]["AWTC"]}}</span>
                                            </div>
                                        </CCol>

                                    </CRow>
                                    <CRow v-if="bool_isAutoDepositBank > 0 && bool_isAutoDepositBank <= 3 && (bool_obj_isAutoDeposit == 11 || bool_obj_isAutoDeposit == 12)&& obj_bankacc.AT == 2 && getUserInfo.AT == 0">
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{getLanguage['BAL']['EAW']}} :</label><br>
                                            <label class="switch">
                                                <input type="checkbox" :checked="obj_bankacc.EAW" @change="v => obj_bankacc.EAW = v.target.checked">
                                                <span class="slider round"></span>
                                            </label>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{getLanguage['BAL']['MAW']}} : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                            <div class="custom_tooltip" style="float:right">
                                                <i class="fa fa-question-circle"></i>
                                                <span class="tooltiptext2 " style=" white-space: pre-line; right: 50%; left: auto; ">{{getLanguage["HELP"]["MAW"]}}</span>
                                            </div>
                                            <CInput size="sm" vertical :value="ThousandSeparator(obj_bankacc.AMAXW, getThousandCurrency ? 3 : 2)" :placeholder="getLanguage['BAL']['MAW']" @change="v => obj_bankacc.AMAXW = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"></CInput>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="bool_isAutoDepositBank > 0 && bool_isAutoDepositBank <= 3 && (bool_obj_isAutoDeposit == 11 || bool_obj_isAutoDeposit == 12)&& obj_bankacc.AT == 2 && getUserInfo.AT == 0">
                                        <CCol col="6">
                                            <label class="col-form-label-sm"> {{getLanguage['BAL']['LDM']}}  : </label>
                                            <CInput size="sm" vertical :value="ThousandSeparator(obj_bankacc.AWDM, 0)" :placeholder="getLanguage['BAL']['LDM']" @change="v => obj_bankacc.AWDM = RemoveThousandSeparator(v, 0)"></CInput>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{getLanguage['BAL']['NWM']}}  : </label>
                                            <div class="custom_tooltip" style="float:right">
                                                <i class="fa fa-question-circle"></i>
                                                <span class="tooltiptext2 " style=" white-space: pre-line; right: 50%; left: auto; ">{{getLanguage["HELP"]["NWM"]}}</span>
                                            </div>
                                            <CInput size="sm" vertical :value="ThousandSeparator(obj_bankacc.AWM, 0)" :placeholder="getLanguage['BAL']['NWM']" @change="v => obj_bankacc.AWM = RemoveThousandSeparator(v,0)"></CInput>
                                        </CCol>

                                    </CRow>



                                    <!-- ADB settings -->
                                    <!-- Auto Deposit -->
                                    <div v-if="IsADBAutoDepositModule" class="sectionDivider subHeaderHR"></div>
                                    <CRow v-if="IsADBAutoDepositModule">
                                        <CCol col="12">
                                            <h6 class="card-title section-title" style="display:inline-block;">
                                                {{getLanguage["BANK"]["AD"]}}
                                            </h6>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="IsADBAutoDepositModule">
                                        <CCol col="6">
                                            <label class="col-form-label-sm" style="display:block">
                                                {{getLanguage["BANK"]["ADTY"]}} :
                                                <div class="custom_tooltip" style="float:right">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="tooltiptext2 time-claim">{{getLanguage["HELP"]["ADTY"]}}</span>
                                                </div>
                                            </label>
                                            <treeselect :multiple="false"
                                                        :options="dd_adty"
                                                        :flat="true"
                                                        :defaultExpandLevel="Infinity"
                                                        @input="isAutoDepositChange"
                                                        v-model="obj_bankacc['IA']" />
                                            <label class="col-form-label-sm" style="display:block">
                                                {{getLanguage['BANK']['HBI']}} :
                                                <div class="custom_tooltip" style="float:right">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="tooltiptext2 time-claim">{{getLanguage["HELP"]["HBI"]}}</span>
                                                </div>
                                            </label>
                                            <label class="switch">
                                                <input type="checkbox" :checked="obj_bankacc.HBI" @change="v => obj_bankacc.HBI = v.target.checked">
                                                <span class="slider round"></span>
                                            </label>
                                        </CCol>
                                        <CCol col="6" v-if="!IsADBAutoWithdrawModule">
                                            <label class="col-form-label-sm">{{getLanguage["BAL"]["BCNO"]}} :</label>
                                            <CInput vertical size="sm" :value="obj_bankacc.BICN" :placeholder="getLanguage['BAL']['BCNO']" @change="v => obj_bankacc.BICN = v" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('BICN', 'BCNO') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="IsADBAutoDepositModule && !IsADBAutoWithdrawModule">
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{getLanguage["BAL"]["IBU"]}} :</label>
                                            <CInput vertical size="sm" :value="obj_bankacc.BU" :placeholder="getLanguage['BANK']['IBU']" @change="v => obj_bankacc.BU = v" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('BU', 'IBU') }}</span>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BAPIN']}} :</label>
                                            <CInput type="password" vertical size="sm" :value="obj_bankacc.BAPIN" :placeholder="getLanguage['BAL']['BAPIN']" @change="v => obj_bankacc.BAPIN = v" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('BAPIN', 'BAPIN') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="IsADBAutoDepositModule && !IsADBAutoWithdrawModule">
                                        <CCol col="6">
                                            <label class="col-form-label-sm full-width">
                                                {{getLanguage["BAL"]["IBP"]}} :
                                                <span v-if="obj_bankacc.LPUTS != null && !isEmptyDate(obj_bankacc.LPUTS)" class="float-right label-tooltip">{{getLanguage["BAL"]["LU"]}} : {{ formatDateTime(obj_bankacc.LPUTS) }}</span>
                                            </label>
                                            <CInput type="password" vertical size="sm" :value="obj_bankacc.BP" :placeholder="getLanguage['BANK']['IBP']" @change="v => obj_bankacc.BP = v" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('BP', 'IBP') }}</span>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{getLanguage["BAL"]["IBPC"]}} :</label>
                                            <CInput type="password"
                                                    vertical size="sm"
                                                    :value="obj_bankacc.BPC"
                                                    :placeholder="getLanguage['BANK']['IBPC']"
                                                    @change="v => obj_bankacc.BPC = v"
                                                    ref="BPC" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('BPC', 'IBPC') }}</span>
                                        </CCol>
                                    </CRow>
                                    <!-- Auto Withdrawal -->
                                    <div v-if="IsADBAutoWithdrawModule && !IsADBAutoDepositModule" class="sectionDivider subHeaderHR"></div>
                                    <br v-if="IsADBAutoWithdrawModule && IsADBAutoDepositModule" />
                                    <CRow v-if="IsADBAutoWithdrawModule">
                                        <CCol col="6">
                                            <h6 class="card-title section-title" style="display:inline-block;">
                                                {{getLanguage['BAL']['AW']}}
                                            </h6>

                                            <div class="custom_tooltip ml-2">
                                                <i class="fa fa-question-circle"></i>
                                                <span class="tooltiptext2" style="white-space: pre-line;  ">{{getLanguage["HELP"]["AWTC"]}}</span>
                                            </div>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="IsADBAutoWithdrawModule">
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{getLanguage['BAL']['EAW']}} :</label><br>
                                            <label class="switch">
                                                <input type="checkbox" :checked="obj_bankacc.EAW" @change="v => obj_bankacc.EAW = v.target.checked">
                                                <span class="slider round"></span>
                                            </label>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{getLanguage['BAL']['MAW']}} : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                            <div class="custom_tooltip" style="float:right">
                                                <i class="fa fa-question-circle"></i>
                                                <span class="tooltiptext2 " style=" white-space: pre-line; right: 50%; left: auto; ">{{getLanguage["HELP"]["MAW"]}}</span>
                                            </div>
                                            <CInput size="sm" vertical :value="ThousandSeparator(obj_bankacc.AMAXW, getThousandCurrency ? 3 : 2)" :placeholder="getLanguage['BAL']['MAW']" @change="v => obj_bankacc.AMAXW = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"></CInput>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="IsADBAutoWithdrawModule">
                                        <CCol col="6">
                                            <label class="col-form-label-sm"> {{getLanguage['BAL']['LDM']}}  : </label>
                                            <CInput size="sm" vertical :value="ThousandSeparator(obj_bankacc.AWDM, 0)" :placeholder="getLanguage['BAL']['LDM']" @change="v => obj_bankacc.AWDM = RemoveThousandSeparator(v, 0)"></CInput>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{getLanguage['BAL']['NWM']}}  : </label>
                                            <div class="custom_tooltip" style="float:right">
                                                <i class="fa fa-question-circle"></i>
                                                <span class="tooltiptext2 " style=" white-space: pre-line; right: 50%; left: auto; ">{{getLanguage["HELP"]["NWM"]}}</span>
                                            </div>
                                            <CInput size="sm" vertical :value="ThousandSeparator(obj_bankacc.AWM, 0)" :placeholder="getLanguage['BAL']['NWM']" @change="v => obj_bankacc.AWM = RemoveThousandSeparator(v,0)"></CInput>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="IsADBAutoWithdrawModule">
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{getLanguage["BAL"]["IBU"]}} :</label>
                                            <CInput vertical size="sm" :value="obj_bankacc.BU" :placeholder="getLanguage['BANK']['IBU']" @change="v => obj_bankacc.BU = v" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('BU', 'IBU') }}</span>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{getLanguage["BAL"]["BCNO"]}} :</label>
                                            <CInput vertical size="sm" :value="obj_bankacc.BICN" :placeholder="getLanguage['BAL']['BCNO']" @change="v => obj_bankacc.BICN = v" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('BICN', 'BCNO') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="IsADBAutoWithdrawModule">
                                        <CCol col="6">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BAPIN']}} :</label>
                                            <CInput type="password" vertical size="sm" :value="obj_bankacc.BAPIN" :placeholder="getLanguage['BAL']['BAPIN']" @change="v => obj_bankacc.BAPIN = v" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('BAPIN', 'BAPIN') }}</span>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BDI']}} :</label>
                                            <CInput vertical size="sm" :value="obj_bankacc.BDI" :placeholder="getLanguage['BAL']['BDI']" @change="v => obj_bankacc.BDI = v" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('BDI', 'BDI') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="IsADBAutoWithdrawModule">
                                        <CCol col="6">
                                            <label class="col-form-label-sm full-width">
                                                {{getLanguage["BAL"]["IBP"]}} :
                                                <span v-if="obj_bankacc.LPUTS != null && !isEmptyDate(obj_bankacc.LPUTS)" class="float-right label-tooltip">{{getLanguage["BAL"]["LU"]}} : {{ formatDateTime(obj_bankacc.LPUTS) }}</span>
                                            </label>
                                            <CInput type="password" vertical size="sm" :value="obj_bankacc.BP" :placeholder="getLanguage['BANK']['IBP']" @change="v => obj_bankacc.BP = v" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('BP', 'IBP') }}</span>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{getLanguage["BAL"]["IBPC"]}} :</label>
                                            <CInput type="password"
                                                    vertical size="sm"
                                                    :value="obj_bankacc.BPC"
                                                    :placeholder="getLanguage['BANK']['IBPC']"
                                                    @change="v => obj_bankacc.BPC = v"
                                                    ref="BPC" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('BPC', 'IBPC') }}</span>
                                        </CCol>
                                    </CRow>
                                    <div v-if="IsADBAutoWithdrawModule || IsADBAutoDepositModule" class="sectionDivider subHeaderHR"></div>
                                    <!-- ADB settings -->

                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{getLanguage["QRC"]["CI"]}} :</label>
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol col="12">
                                            <CTabs variant='tabs' id="imageURLTab">
                                                <CTab :title="getLanguage['CTAB']['UI']" :active="obj_bankacc.IUT === false ? true: false">
                                                    <img v-if="obj_bankacc['I'] > 0 && obj_bankacc['QRCI']"
                                                         width="auto"
                                                         height="150"
                                                         class="mb-2"
                                                         :src="getImgUrl(obj_bankacc['QRCI'])" />
                                                    <div class="custom-file">
                                                        <input type="file" class="custom-file-input" id="validatedCustomFile" name="pic" accept="image/*" @change="onFileSelected" required>
                                                        <label class="custom-file-label" for="validatedCustomFile" v-if="selectedFile === null">{{ getLanguage['CTAB']['CAI'] }}</label>
                                                        <label class="custom-file-label" for="validatedCustomFile" v-else>{{selectedFile.name}}</label>
                                                        <div class="invalid-feedback">{{ getLanguage['ERR']['8007'] }}</div>
                                                    </div>
                                                    <label class="col-form-label-sm">{{getLanguage["RIZ"]["IZ"]}} : 200 x 200</label>
                                                </CTab>
                                                <CTab :title="getLanguage['CTAB']['U']" :active="obj_bankacc.IUT === true ? true: false">
                                                    <img v-if="obj_bankacc['I'] > 0 && obj_bankacc['QRCI']"
                                                         width="auto"
                                                         height="150"
                                                         class="mb-2"
                                                         :src="getImgUrl(obj_bankacc['QRCI'])" />
                                                    <label class="sr-only" for="inlineFormInputGroupUsername">{{ getLanguage['CTAB']['U'] }}</label>
                                                    <div class="input-group">
                                                        <div class="input-group-prepend">
                                                            <div class="input-group-text">{{ getLanguage['CTAB']['U'] }}</div>
                                                        </div>
                                                        <input type="url" class="form-control" :placeholder="getLanguage['CTAB']['U']" v-model="obj_bankacc.QRCI">
                                                    </div>
                                                    <label class="col-form-label-sm">{{getLanguage["RIZ"]["IZ"]}} : 200 x 200</label>
                                                </CTab>
                                            </CTabs>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveBankAccount()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>

            </transition>
        </div>

        <div v-if="bool_isAAB">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width: 70%; max-width: 600px;">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="8">
                                        <h2 id="titleHeight">
                                            {{getLanguage["BA"]["AAB"]}}
                                        </h2>
                                    </CCol>
                                    <CCol col="4">

                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeAddBankAccount()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm pb-0"> {{getLanguage["BA"]["BN"]}}:</label>
                                            <div class="bold">{{obj_bankacc.BN}}</div>

                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm pb-0">{{getLanguage["BA"]["BAN"]}}:</label>
                                            <div class="bold">{{obj_bankacc.BA}}</div>

                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm pt-3 pb-0">{{getLanguage["BA"]["BANO"]}}:</label>
                                            <div class="bold">{{obj_bankacc.BAN}}</div>

                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm pt-3 pb-0"> {{getLanguage["BAL"]["B"]}}:</label>
                                            <div class="bold">{{ formatNumber(obj_bankacc.AB, getThousandCurrency ? 3 : 2, obj_bankacc.CS) }}</div>

                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol>
                                            <label class="col-form-label-sm pt-3">{{getLanguage["BA"]["EAA"]}}<span class="required" /> :</label>
                                            <CInput vertical size="sm" :prepend="obj_bankacc.CS" :value="ThousandSeparator(obj_bankacc.Add_AB, getThousandCurrency ? 3 : 2)" @change="v => obj_bankacc.Add_AB = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('Add_AB','B') }}</span>

                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol>
                                            <label class="col-form-label-sm">{{getLanguage["BA"]["R"]}}</label>
                                            <CInput vertical size="sm" :placeholder="getLanguage['BA']['ED']" :value="obj_bankacc.R" @change="v => obj_bankacc.R = v" />
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol>
                                            <div style="text-align:center;margin-top:20px">
                                                <CButton color="outline-info" size="sm" @click="saveBankAccountBalance('m')">
                                                    <span class='fa-minus'></span>
                                                    {{getLanguage["BTN"]["MINUS"]}}
                                                </CButton>
                                                <CButton color="outline-info" size="sm" @click="saveBankAccountBalance('p')">
                                                    <span class='plusIcon cil-plus'></span>
                                                    {{getLanguage["AG"]["TUSB"]}}
                                                </CButton>
                                            </div>
                                        </CCol>
                                    </CRow>

                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isADAPP">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width: 70%; max-width: 600px;">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="8">
                                        <h2 id="titleHeight">
                                            {{getLanguage["BAL"]["ADSACC"]}}
                                        </h2>
                                    </CCol>
                                    <CCol col="4">

                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeSetupBankAccount()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="12">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BCT']}} :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_adbct"
                                                        :flat="true"
                                                        :defaultExpandLevel="Infinity"
                                                        v-model="obj_bankAD['BCT']"
                                                        @input="SCBCardTypeChange"
                                                        :readonly="int_obj_autoDepositAppStep==1" />
                                            <span class="ErrMsg">{{ ValidationErrMsgAD('BCT', 'BCT') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="bool_showSCBPassportCountry">
                                        <CCol col="12">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['CC']}} :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_cc"
                                                        :clearable="false"
                                                        :flat="true"
                                                        :defaultExpandLevel="Infinity"
                                                        v-model="obj_bankAD['BCC']" />
                                            <span class="ErrMsg">{{ ValidationErrMsgAD('BCC', 'CC') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BICN']}} :</label>
                                            <CInput vertical size="sm" :value="obj_bankAD.BICN" :placeholder="getLanguage['BAL']['BICN']" @change="v => obj_bankAD.BICN = v" :readonly="int_obj_autoDepositAppStep==1" />
                                            <span class="ErrMsg">{{ ValidationErrMsgAD('BICN', 'BICN') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BDOB']}} :</label>
                                            <date-range-picker :show-dropdowns="true"
                                                               opens="center"
                                                               v-model="obj_bankAD.BDOBpicker"
                                                               :auto-apply="true"
                                                               :ranges="false"
                                                               :single-date-picker="true"
                                                               :readonly="int_obj_autoDepositAppStep==1">
                                                <div slot="input" slot-scope="picker">
                                                    <div v-if="obj_bankAD.BDOBpicker.startDate != ''">
                                                        <CInput size="sm"
                                                                :value="obj_bankAD.BDOBpicker.startDate | moment('DD MMM YYYY')"
                                                                @change="DateTimeChange('BDOB',$event)"
                                                                :readonly="int_obj_autoDepositAppStep==1" />
                                                    </div>
                                                    <div v-else>
                                                        <CInput size="sm" @change="DateTimeChange('BDOB',$event)"
                                                                :readonly="int_obj_autoDepositAppStep==1" />
                                                    </div>
                                                </div>
                                            </date-range-picker>
                                            <span class="ErrMsg">{{ ValidationErrMsgAD('BDOB', 'BDOB') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BMN']}} :</label>
                                            <CInput vertical size="sm" :value="obj_bankAD.BMN" :placeholder="getLanguage['BAL']['BMN']" @change="v => obj_bankAD.BMN = v" :readonly="int_obj_autoDepositAppStep==1" />
                                            <span class="ErrMsg">{{ ValidationErrMsgAD('BMN', 'BMN') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BAPIN']}} :</label>
                                            <CInput type="password" vertical size="sm" :value="obj_bankAD.BAPIN" :placeholder="getLanguage['BAL']['BAPIN']" @change="v => obj_bankAD.BAPIN = v" :readonly="int_obj_autoDepositAppStep==1" />
                                            <span class="ErrMsg">{{ ValidationErrMsgAD('BAPIN', 'BAPIN') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12" v-if="int_obj_autoDepositAppStep==0">
                                            <CButton color="outline-info" size="sm" @click="autoDepositStep1()">
                                                <span class='plusIcon cil-plus'></span>
                                                {{this.getLanguage["BTN"]["ADOTP"]}}
                                            </CButton>
                                        </CCol>
                                        <CCol col="12" v-if="int_obj_autoDepositAppStep==1">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['ADOTP']}} :</label>
                                            <CInput vertical size="sm" :value="obj_bankAD.OTP" :placeholder="getLanguage['BAL']['ADOTP']" @change="v => obj_bankAD.OTP = v" :readonly="int_obj_autoDepositAppStep==0" />
                                            <span class="ErrMsg">{{ ValidationErrMsgAD('OTP', 'ADOTP') }}</span>
                                            <CButton color="outline-info" size="sm" @click="autoDepositStep2()">
                                                <span class='plusIcon cil-plus'></span>
                                                {{this.getLanguage["BTN"]["ADVOTP"]}}
                                            </CButton>
                                            <CButton color="outline-info" size="sm" @click="backAutoDepositStep1()">
                                                {{this.getLanguage["BTN"]["BK"]}}
                                            </CButton>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12">
                                            <span class="ErrMsg">{{ AutoDepositSetupError() }}</span>
                                        </CCol>
                                    </CRow>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isADAPPWithdraw">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width: 70%; max-width: 600px;">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="8">
                                        <h2 id="titleHeight">
                                            {{getLanguage["BAL"]["ADWD"]}}
                                        </h2>
                                    </CCol>
                                    <CCol col="4">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeAccountWithdrawal()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="12">
                                            <h6 id="titleHeight">{{getLanguage["BAL"]["ADTF"]}}</h6>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BANM']}} :</label>
                                            {{ obj_bankADWithdraw['sBA'] }}
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BANO']}} :</label>
                                            {{ obj_bankADWithdraw['sBAN'] }}
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['B']}} :</label>
                                            {{ ThousandSeparator(obj_bankADWithdraw['sBAL'], getThousandCurrency ? 3 : 2) }}
                                        </CCol>
                                    </CRow>
                                    <br /><div class='subHeaderHR'></div><br />
                                    <CRow>
                                        <CCol col="12">
                                            <h6 id="titleHeight">{{getLanguage["BAL"]["ADTT"]}}</h6>
                                        </CCol>
                                    </CRow>
                                    <!-- fill in transfer to info -->
                                    <CRow v-if="int_obj_autoDepositWithdrawStep==0">
                                        <CCol col="6">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BN']}} :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_adbnl"
                                                        :flat="true"
                                                        :defaultExpandLevel="Infinity"
                                                        :max-height="200"
                                                        v-model="obj_bankADWithdraw['recBC']"
                                                        :disabled="int_obj_autoDepositWithdrawStep==1" />
                                            <span class="ErrMsg">{{ ValidationErrMsgADWithdraw('recBC', 'BN') }}</span>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BANO']}} :</label>
                                            <CInput vertical size="sm" :value="obj_bankADWithdraw.recBAN" :placeholder="getLanguage['BAL']['BANO']" @change="v => obj_bankADWithdraw.recBAN = v" :readonly="int_obj_autoDepositWithdrawStep==1" />
                                            <span class="ErrMsg">{{ ValidationErrMsgADWithdraw('recBAN', 'BANO') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="int_obj_autoDepositWithdrawStep==0">
                                        <CCol col="6">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['ADTA']}} :</label>
                                            <CInput size="sm" vertical :value="obj_bankADWithdraw.TA != null ? ThousandSeparator(obj_bankADWithdraw.TA, getThousandCurrency ? 3 : 2) : obj_bankADWithdraw.TA" :placeholder="getLanguage['BAL']['ADTA']"
                                                    @change="v => obj_bankADWithdraw.TA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" :readonly="int_obj_autoDepositWithdrawStep==1"></CInput>
                                            <span class="ErrMsg">{{ ValidationErrMsgADWithdraw('TA', 'ADTA') }}</span>
                                        </CCol>
                                        <CCol col="6" v-if="int_obj_autoDepositWithdrawStep==0">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BAPIN']}} :</label>
                                            <CInput type="password" vertical size="sm" :value="obj_bankADWithdraw.BAPIN" :placeholder="getLanguage['BAL']['BAPIN']" @change="v => obj_bankADWithdraw.BAPIN = v" />
                                            <span class="ErrMsg">{{ ValidationErrMsgADWithdraw('BAPIN', 'BAPIN') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="int_obj_autoDepositWithdrawStep==0">
                                        <CCol col="12">
                                            <CButton color="outline-info" size="sm" @click="AutoDepositWithdraw()">
                                                {{this.getLanguage["BTN"]["WD"]}}
                                            </CButton>
                                        </CCol>
                                    </CRow>

                                    <!--confirm transfer to info-->
                                    <CRow v-if="int_obj_autoDepositWithdrawStep==1">
                                        <CCol col="6">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['ADTT']}} :</label>
                                            {{ obj_bankADWithdraw['recAccTo'] }}
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BANM']}} :</label>
                                            {{ obj_bankADWithdraw['recAccToDN'] }}
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="int_obj_autoDepositWithdrawStep==1">
                                        <CCol col="6">
                                            <label class="col-form-label-sm full-width">{{getLanguage['BAL']['ADTA']}} :</label>
                                            {{ ThousandSeparator(obj_bankADWithdraw.TA, getThousandCurrency ? 3 : 2) }}
                                        </CCol>

                                    </CRow>
                                    <CRow v-if="int_obj_autoDepositWithdrawStep==1">
                                        <CCol col="12">
                                            <CButton color="outline-info" size="sm" @click="AutoDepositConfirmWithdraw()">
                                                {{this.getLanguage["GL"]["CONFIRM"]}}
                                            </CButton>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12">
                                            <span class="ErrMsg">{{ AutoDepositWithdrawError() }}</span>
                                        </CCol>
                                    </CRow>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_fullPreview">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["GL"]["P"]}}</h4>
                                    </CCol>
                                    <CCol col="4">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd1">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content text-center">
                                    <img :src="previewUrl" class="img-fluid" v-if="previewUrl">
                                    <p v-else>{{this.getLanguage['GL']['NR']}}</p>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage[["GL"]]["NO"]}}
                                            </template>
                                            <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete))">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["ACT"]}}
                                            </template>
                                            <template v-else-if="header == 'RS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage["BAL"]["S"]}}
                                                <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'AGN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["DM"]["AGI"]}}
                                                <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'CUR'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["BAL"]["C"]}}
                                                <i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'ACCT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage["BAL"]["AT"]}}
                                            </template>
                                            <template v-else-if="header == 'BN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["BAL"]["BN"]}}
                                            </template>
                                            <template v-else-if="header == 'BL'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["BAL"]["B"]}}
                                                <i @click="setSortTable('AB')" :class="setSortLogo('AB')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'PM'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MDB"]["PM"]}}
                                            </template>
                                            <template v-else-if="header == 'BAC'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["BAL"]["BANM"]}}
                                            </template>
                                            <template v-else-if="header == 'BACNO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage["BAL"]["BANO"]}}
                                            </template>
                                            <template v-else-if="header == 'CC'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage["BAL"]["CC"]}}
                                                <i @click="setSortTable('CC')" :class="setSortLogo('CC')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'MIDPT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage['BANK']["MIND"]}}
                                                <i @click="setSortTable('MIND')" :class="setSortLogo('MIND')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'MXDPT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage['BANK']["MAXD"]}}
                                                <i @click="setSortTable('MAXD')" :class="setSortLogo('MAXD')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TDL'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage['BANK']["MAXDACCT"]}}
                                                <i @click="setSortTable('MAXDACCT')" :class="setSortLogo('MAXDACCT')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'ADA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage['BANK']["ADEPAMT"]}}
                                                <i @click="setSortTable('ADEPAMT')" :class="setSortLogo('ADEPAMT')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'MIWPT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage['BANK']["MINW"]}}
                                                <i @click="setSortTable('MINW')" :class="setSortLogo('MINW')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'MXWPT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage['BANK']["MAXW"]}}
                                                <i @click="setSortTable('MAXW')" :class="setSortLogo('MAXW')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'MXWPD'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['BANK']["TW"]}}
                                            </template>
                                            <template v-else-if="header == 'IURL'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["BAL"]["QRUR"]}}
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{ this.getLanguage["BAL"]["BAL"] }}</h2>
                        <CButton size="sm" color="outline-info" v-if="checkModuleAccess2(constAccessType.add)" @click="addBankAccount()"> <span class='plusIcon cil-plus'></span>{{getLanguage["BTN"]["AN"]}} </CButton>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["DM"]["AGI"]}} :</span>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroupfs"
                                                  :flat="true"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  v-model="str_FV[11].FV"
                                                  @input="AgentGroupChangefs" />
                            </div>

                            <div class='searchCol'>
                                <label class=" searchLabel">{{getLanguage["BAL"]["S"]}} :</label>
                                <treeselect :multiple="false"
                                            :options="arry_status"
                                            placeholder
                                            v-model="str_FV[6].FV" />
                            </div>

                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="str_FV[13].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[13].FV.startDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[13].FV.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="str_FV[13].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[13].FV.endDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[13].FV.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>

                            <div class='searchCol'>
                                <label class="searchLabel">{{getLanguage["BAL"]["BN"]}} :</label>
                                <CInput vertical
                                        type="text"
                                        size="sm"
                                        :value="str_FV[0].FV" @change="v => str_FV[0].FV = v" />
                            </div>

                            <div class='searchCol'>
                                <label class=" searchLabel">{{getLanguage["BAL"]["C"]}} :</label>
                                <treeselect :multiple="false"
                                            :options="dd_currency_s"
                                            placeholder
                                            v-model="str_FV[1].FV" />
                            </div>
                            <div class='searchCol'>
                                <label class=" searchLabel">{{getLanguage["BAL"]["AT"]}} :</label>
                                <treeselect :multiple="false"
                                            :options="arry_accType"
                                            placeholder
                                            v-model="holdAT_FV"
                                            @input="ChangeAT" />
                            </div>

                            <div class='searchCol'>
                                <label class=" searchLabel">{{getLanguage["BAL"]["BMT"]}} :</label>
                                <CInput vertical
                                        size="sm"
                                        :value="ThousandSeparator(str_FV[4].FV)"
                                        @change="v => str_FV[4].FV = RemoveThousandSeparator(v)" />
                            </div>

                            <div class='searchCol'>
                                <label class=" searchLabel">{{getLanguage["BAL"]["BLT"]}} :</label>
                                <CInput vertical
                                        size="sm"
                                        :value="ThousandSeparator(str_FV[5].FV)"
                                        @change="v => str_FV[5].FV = RemoveThousandSeparator(v)" />
                            </div>

                            <div class='searchCol'>
                                <label class="searchLabel"> {{getLanguage['BAL']["CC"]}} :</label>
                                <treeselect :multiple="true"
                                            :options="dd_cc"
                                            v-model="str_FV[12].FV"
                                            placeholder
                                            :flat="true"
                                            :defaultExpandLevel="Infinity"
                                            :limit="1"
                                            :limitText="count => `+${count}`" />
                            </div>

                            <div class='searchCol'>
                                <label class=" searchLabel"> {{getLanguage['BANK']["MIND"]}} :</label>
                                <CInput vertical
                                        size="sm"
                                        :value="ThousandSeparator(str_FV[7].FV)"
                                        @change="v => str_FV[7].FV = RemoveThousandSeparator(v)" />
                            </div>
                            <div class='searchCol'>
                                <label class=" searchLabel"> {{getLanguage['BANK']["MAXD"]}} :</label>
                                <CInput vertical
                                        size="sm"
                                        :value="ThousandSeparator(str_FV[8].FV)"
                                        @change="v => str_FV[8].FV = RemoveThousandSeparator(v)" />
                            </div>
                            <div class='searchCol'>
                                <label class=" searchLabel"> {{getLanguage['BANK']["MAXDACCT"]}} :</label>
                                <CInput vertical
                                        size="sm"
                                        :value="ThousandSeparator(str_FV[15].FV)"
                                        @change="v => str_FV[15].FV = RemoveThousandSeparator(v)" />
                            </div>
                            <div class='searchCol'>
                                <label class=" searchLabel"> {{getLanguage['BANK']["ADEPAMT"]}} :</label>
                                <CInput vertical
                                        size="sm"
                                        :value="ThousandSeparator(str_FV[16].FV)"
                                        @change="v => str_FV[16].FV = RemoveThousandSeparator(v)" />
                            </div>
                            <div class='searchCol'>
                                <label class=" searchLabel"> {{getLanguage['BANK']["MINW"]}} :</label>
                                <CInput vertical
                                        size="sm"
                                        :value="ThousandSeparator(str_FV[9].FV)"
                                        @change="v => str_FV[9].FV = RemoveThousandSeparator(v)" />
                            </div>
                            <div class='searchCol'>
                                <label class=" searchLabel">{{getLanguage['BANK']["MAXW"]}} :</label>
                                <CInput vertical
                                        size="sm"
                                        :value="ThousandSeparator(str_FV[10].FV)"
                                        @change="v => str_FV[10].FV = RemoveThousandSeparator(v)" />
                            </div>
                            <div class='searchCol'>
                                <label class=" searchLabel">{{getLanguage["BAL"]["VIP"]}} :</label>
                                <treeselect :multiple="false"
                                            :options="arry_vip"
                                            placeholder
                                            v-model="str_FV[14].FV" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" ref="search" class='searchBtn' size="sm" block color="success" @click=" newSearch()"><span class='searchIcon cil-search'></span><span> {{getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>


            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{getLanguage['BAL']['BAL']}}</strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage[["GL"]]["NO"]}}
                                    </template>
                                    <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                    <template v-else-if="header == 'RS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage["BAL"]["S"]}}
                                        <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AGN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["DM"]["AGI"]}}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CUR'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["BAL"]["C"]}}
                                        <i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ACCT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage["BAL"]["AT"]}}
                                    </template>
                                    <template v-else-if="header == 'BN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["BAL"]["BN"]}}
                                    </template>
                                    <template v-else-if="header == 'BL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["BAL"]["B"]}}
                                        <i @click="setSortTable('AB')" :class="setSortLogo('AB')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PM'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MDB"]["PM"]}}
                                    </template>
                                    <template v-else-if="header == 'BAC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["BAL"]["BANM"]}}
                                    </template>
                                    <template v-else-if="header == 'BACNO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage["BAL"]["BANO"]}}
                                    </template>
                                    <template v-else-if="header == 'CC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage["BAL"]["CC"]}}
                                        <i @click="setSortTable('CC')" :class="setSortLogo('CC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MIDPT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage['BANK']["MIND"]}}
                                        <i @click="setSortTable('MIND')" :class="setSortLogo('MIND')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MXDPT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage['BANK']["MAXD"]}}
                                        <i @click="setSortTable('MAXD')" :class="setSortLogo('MAXD')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TDL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage['BANK']["MAXDACCT"]}}
                                        <i @click="setSortTable('MAXDACCT')" :class="setSortLogo('MAXDACCT')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ADA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage['BANK']["ADEPAMT"]}}
                                        <i @click="setSortTable('ADEPAMT')" :class="setSortLogo('ADEPAMT')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MIWPT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage['BANK']["MINW"]}}
                                        <i @click="setSortTable('MINW')" :class="setSortLogo('MINW')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MXWPT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage['BANK']["MAXW"]}}
                                        <i @click="setSortTable('MAXW')" :class="setSortLogo('MAXW')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MXWPD'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BANK']["TW"]}}
                                    </template>
                                    <template v-else-if="header == 'IURL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["BAL"]["QRUR"]}}
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage[["GL"]]["NO"]}}
                                    </template>
                                    <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                    <template v-else-if="header == 'RS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage["BAL"]["S"]}}
                                        <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AGN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["DM"]["AGI"]}}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('PC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CUR'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["BAL"]["C"]}}
                                        <i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ACCT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage["BAL"]["AT"]}}
                                    </template>
                                    <template v-else-if="header == 'BN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["BAL"]["BN"]}}
                                    </template>
                                    <template v-else-if="header == 'BL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["BAL"]["B"]}}
                                        <i @click="setSortTable('AB')" :class="setSortLogo('AB')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PM'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MDB"]["PM"]}}
                                    </template>
                                    <template v-else-if="header == 'BAC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["BAL"]["BANM"]}}
                                    </template>
                                    <template v-else-if="header == 'BACNO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage["BAL"]["BANO"]}}
                                    </template>
                                    <template v-else-if="header == 'CC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage["BAL"]["CC"]}}
                                        <i @click="setSortTable('CC')" :class="setSortLogo('CC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MIDPT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage['BANK']["MIND"]}}
                                        <i @click="setSortTable('MIND')" :class="setSortLogo('MIND')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MXDPT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage['BANK']["MAXD"]}}
                                        <i @click="setSortTable('MAXD')" :class="setSortLogo('MAXD')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TDL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage['BANK']["MAXDACCT"]}}
                                        <i @click="setSortTable('MAXDACCT')" :class="setSortLogo('MAXDACCT')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ADA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage['BANK']["ADEPAMT"]}}
                                        <i @click="setSortTable('ADEPAMT')" :class="setSortLogo('ADEPAMT')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MIWPT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage['BANK']["MINW"]}}
                                        <i @click="setSortTable('MINW')" :class="setSortLogo('MINW')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MXWPT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage['BANK']["MAXW"]}}
                                        <i @click="setSortTable('MAXW')" :class="setSortLogo('MAXW')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MXWPD'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BANK']["TW"]}}
                                    </template>
                                    <template v-else-if="header == 'IURL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["BAL"]["QRUR"]}}
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_lcl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_lcl" v-bind:key="index">
                            <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header)">
                                <template v-if="header == 'NO'">
                                    {{ CountItem(index+1)}}
                                </template>
                                <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete))">
                                    <span id="actionBtnCol">
                                        <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                            <i class="cil-trash" @click='removeBankAccount(data)'></i> <!--here Remove -->
                                            <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-else-if="(isSENS == 1 && data.AGI != curAGI)">
                                            <i class="cil-trash"></i> <!--here Remove -->
                                            <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                            <i class="cil-color-border" @click='editBankAccount(data.I)'></i>  <!--here Edit -->
                                            <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-else-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI)">
                                            <i class="cil-color-border"></i>  <!--here Edit -->
                                            <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                            <i class="cil-cash" @click='addAccountBalance(data.I)'></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["MB"]}}</span>
                                        </div><div class="custom_tooltip" v-else-if="(isSENS == 1 && data.AGI != curAGI)">
                                            <i class="cil-cash"></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["MB"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="checkBankAccountIsAuto(data.IA) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                            <i class="cil-list-rich" @click='bankStatementList(data.AGI, data.I)'>
                                                <span class="badge rounded-circle ml-auto mini-count" style="background:rgb(229, 54, 54);color:#fff;" v-if="data.ADPC>0">{{ data.ADPC }}</span>
                                            </i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["BSRP"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-else-if="checkBankAccountIsAuto(data.IA) && (isSENS == 1 && data.AGI != curAGI)">
                                            <i class="cil-list-rich">
                                                <span class="badge rounded-circle ml-auto mini-count" style="background:rgb(229, 54, 54);color:#fff;" v-if="data.ADPC>0">{{ data.ADPC }}</span>
                                            </i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["BSRP"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.IA == 2 && getUserInfo.AT == 0">
                                            <i class="cil-find-in-page" @click='triggerPullStatement(data)'></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["PBS"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="checkSCBAPPIsAuto(data.IA)">
                                            <i class="cil-dollar" @click='triggerWithdraw(data)'></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["WD"]}}</span>
                                        </div>
                                    </span>
                                </template>
                                <template v-else-if="header == 'RS'">
                                    <CCol col="4" v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <label class="switch">
                                            <input type="checkbox" v-if="data.RS == '2'" checked @change="saveBankAccountStatus(data, 1)" :id="index" :disabled="!checkModuleAccess2(constAccessType.edit)">
                                            <input type="checkbox" v-else @change="saveBankAccountStatus(data, 2)" :id="index" :disabled="!checkModuleAccess2(constAccessType.edit)">
                                            <span class="slider round" :style="disabledPointer()"></span>
                                        </label>
                                    </CCol>
                                    <CCol col="4" v-else-if="(isSENS == 1 && data.AGI != curAGI)">
                                        <label class="switch">
                                            <input type="checkbox" v-if="data.RS == '2'" :id="index" :disabled="!checkModuleAccess2(constAccessType.edit)">
                                            <input type="checkbox" v-else :id="index" :disabled="!checkModuleAccess2(constAccessType.edit)">
                                            <span class="slider round" :style="disabledPointer()"></span>
                                        </label>
                                    </CCol>
                                </template>
                                <template v-else-if="header == 'AGN'">
                                    {{ data.GN }} ({{ data.PC }})
                                </template>
                                <template v-else-if="header == 'CUR'">
                                    {{ data.CN }} ({{data.ISOC}})
                                </template>
                                <template v-else-if="header == 'ACCT'">
                                    {{ checkAT(data.ID,data.IW) }}
                                </template>
                                <template v-else-if="header == 'BN'">
                                    <span>{{ data.BN }}</span>
                                    <span v-html="getAutoDeposit(data.IA)"></span>
                                    <br />
                                    <a href="javascript:void(0)" style="color:blue" @click="setPreview(data.BL)" v-if="data.BL && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <u>{{getLanguage["GL"]["P"]}}</u>
                                    </a>
                                    <a href="javascript:void(0)" style="color:blue" v-else-if="data.BL && (isSENS == 1 && data.AGI != curAGI)">
                                        <u>{{getLanguage["GL"]["P"]}}</u>
                                    </a>
                                </template>
                                <template v-else-if="header == 'BL'">
                                    {{ formatNumber(data.AB, 2, data.CS) }}
                                </template>
                                <template v-else-if="header == 'PM'">
                                    <template v-if="data.PM.length > 0">
                                        <template v-for="item in dd_pm" v-if="data.PM.includes(item.id)">
                                            {{item.label}}<br />
                                        </template>
                                    </template>
                                    <template v-else>
                                        -
                                    </template>
                                </template>
                                <template v-else-if="header == 'BAC'">
                                    {{ data.BA }}
                                    <i v-if="data.VIPBA" class="fa fa-crown" style="color: rgb(201, 84, 90);"></i>
                                </template>
                                <template v-else-if="header == 'BACNO'">
                                    {{ data.BAN }}
                                </template>
                                <template v-else-if="header == 'CC'">
                                    {{ ConvertCountryCode(data.CC) }}
                                </template>
                                <template v-else-if="header == 'MIDPT'">
                                    {{ formatNumber(data.MIND, 2, data.CS) }}
                                </template>
                                <template v-else-if="header == 'MXDPT'">
                                    {{ formatNumber(data.MAXD, 2, data.CS) }}
                                </template>
                                <template v-else-if="header == 'TDL'">
                                    {{ formatNumber(data.TD, 2, data.CS) }}
                                </template>
                                <template v-else-if="header == 'ADA'">
                                    {{ formatNumber(data.TUD, 2, data.CS) }}
                                </template>
                                <template v-else-if="header == 'MIWPT'">
                                    {{ formatNumber(data.MINW, 2, data.CS) }}
                                </template>
                                <template v-else-if="header == 'MXWPT'">
                                    {{ formatNumber(data.MAXW, 2, data.CS) }}
                                </template>
                                <template v-else-if="header == 'MXWPD'">
                                    {{ formatNumber(data.TW, 2, data.CS) }}
                                </template>
                                <template v-else-if="header == 'IURL'">
                                    <a href="javascript:void(0)" style="color:blue" @click="setPreview(data.QRCI)" v-if="data.QRCI && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <u>{{getLanguage["GL"]["P"]}}</u>
                                    </a>
                                    <a href="javascript:void(0)" style="color:blue" v-if="data.QRCI && (isSENS == 1 && data.AGI != curAGI)">
                                        <u>{{getLanguage["GL"]["P"]}}</u>
                                    </a>
                                </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import DateRangePicker from 'vue2-daterange-picker'
    //you need to import the CSS manually (in case you want to override it)
    import Loading from 'vue-loading-overlay';
    import { mapGetters, mapActions } from 'vuex'
    import { required, requiredIf, sameAs, decimal, maxValue, minValue, alphaNum, helpers, maxLength } from 'vuelidate/lib/validators'
    import genericHelper from "@/modules/GenericHelper.js";
    import { constAccessType, constCountryCode, constAutoDepositType, constAutoDepositBankApp, loadingFullScreen, constSCBAppCardType, constSCBAppBankNameList, constADBBankList, constADBDepoBankList } from '@/modules/Constant.js'
    import moment from "moment";
    import Vue from 'vue';
    import $ from 'jquery'
    import Sortable from 'sortablejs';
    import draggable from 'vuedraggable';
    // const alphaNumAndDotValidator = helpers.regex('alphaNumAndDot', /^[a-z\d.]*$/i);
    //Vue.use(require('vue-shortkey'))

    function validateUrl(value) {
        if (this.obj_bankacc.PLURL != null && this.obj_bankacc.PLURL != '')
        {

            var pattern = /^(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9]+([-a-zA-Z0-9@:%._\+~#=]{0,253}[a-zA-Z0-9])?\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/g

            return pattern.test(this.obj_bankacc.PLURL);
        }
        return true;
    }

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Loading,
            DateRangePicker,
            Sortable,
            draggable
        },
        props: {

        },
        data() {
            return {
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_isAMV: false, // Add Modal Visible
                bool_isAAB: false,
                bool_isADAPP: false,
                bool_isADAPPWithdraw: false,
                bool_fullPreview: false,
                bool_showSearchBar: true,
                bool_isDisablePLURL: false,
                int_lblPage: 1,
                timeout: null,
                //the parameter of getList()
                int_Page: 1,//current Pagr
                int_IC: 1, // Item Count
                int_RC: 100, //Row Count
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                str_FV: [{ F: "bn" }, { F: "ci" }, { F: "iw" }, { F: "id" }, { F: "ab_from" }, { F: "ab_to" },
                { F: "rs" }, { F: "mind" }, { F: "maxd" }, { F: "minw" }, { F: "maxw" }, { F: "agi" }, { F: "CC_csv" }, {
                    F: "CTS", FV: {
                        startDate: "",
                        endDate: ""
                    }
                }, { F: "vipba" }, { F: "td" }, { F: "tud" }], //Filter Value
                //ctrl Page valuev (A return Data )
                int_TI: 0,//Total Items
                int_TP: 1, //Total Page
                //array hold data
                bool_CV: false, // Check Validation
                bool_ADCV: false,
                bool_ADWitdrawCV: false,
                arry_lcl: [], //BankAccount List
                obj_bankacc: {
                    I: 0,
                    RS: 1,
                    VIPBA: false,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    AT: null,
                    BI: null,
                    BA: "",
                    BAN: "",
                    CI: null,
                    Add_AB: null,
                    TT: null,
                    AB: null,
                    MINW: null,
                    MAXW: null,
                    MIND: null,
                    MAXD: null,
                    TD: null,
                    TUD: null,
                    TW: null,
                    AGI: null,
                    ID: null,
                    IW: null,
                    ISDL: 0,
                    CC: null,
                    BU: "",
                    BP: "",
                    BPC: "",
                    R: "",
                    IA: null,
                    UDB: false,
                    ADS: "",
                    ADR: "",
                    LPUTS: null,
                    IUT: false,
                    QRCI: "",
                    MT: [],
                    MTV: [],  // Member Type Values
                    EAW:false, //EnableAutoWithdrawal
                    AMAXW:0, //AutoMAXWithdrawal
                    AWDM:0, //AutoWDepositMultiplier
                    AWM:15,  //AutoWithdrawalMinutes
                    PLURL: "",
                    BICN: "",
                    BDOB: "",
                    BMN: "",
                    BAPIN: "",
                    BDI: "",
                    BCT: null,
                    FCS: "",
                    ER: 1,
                    TCS: "",
                    TER: 1,
                    PM: [],
                    HBI:false
                }, //Add BankAccount

                obj_bankAD: {
                    BICN: "",
                    BDOBpicker: { startDate: '' },
                    BDOB: "",
                    BMN: "",
                    BAPIN: "",
                    BCT: "P1",
                    BCC: "",

                    OTP: "",
                    APIAuth: "",
                    Token: "",
                },
                obj_bankADWithdraw: {
                    sBAI: 0,
                    sBA: "",
                    sBAN: "",
                    sBAL: 0,
                    recBAN: "",
                    recBC: null,
                    TA: null,
                    BAPIN: "",

                    recAccTo: "",
                    recAccToDN: ""
                },
                dd_currency: [],//currecny dropdown
                dd_currency_s: [],//currecny dropdown
                dd_bank: [],
                dd_agentgroup: [],
                dd_agentgroupfs: [],
                dd_cc: [],
                bool_isD: false,
                bool_isW: false,
                bool_errminmax: false,
                bool_isAutoDepositBank: 0,
                holdAT_FV: null,
                bool_obj_bankaccRS: true, // a bool to hold obj Status
                bool_obj_bankaccDC: false, // is the bank with different currency to member
                arry_accType: [],
                //arry_accType: [{ id: "0", label: "Withdrawal" }, { id: "1", label: "Deposit" }, { id: "2", label: "Deposit And Withdrawal" }],
                arry_status: [],
                //arry_status: [{ id: "1", label: "Inactive" }, { id: "2", label: "Active" }],
                arry_vip: [],
                //arry_vip: [{ id: "", label: "All" }, { id: "1", label: "Yes" }, { id: "2", label: "No" }],
                // arry_holdLang:[]//obj  to hold language
                constAccessType: constAccessType,
                bool_obj_isAutoDeposit: 0,
                int_obj_autoDepositAppStep: 0,
                int_obj_autoDepositWithdrawStep: 0,
                bool_showSCBPassportCountry: false,
                str_autoDepositCode: "",
                str_autoDepositErrMsg: "",
                str_autoDepositWithdrawErrMsg: "",
                dd_adty: [],
                dd_adbct: constSCBAppCardType,
                dd_adbnl: constSCBAppBankNameList,
                newImg: false,
                selectedFile: null,
                ddEditMemberTypeList: [],
                previewUrl: null,
                defaultReportHeaders: ['NO', 'ACT', 'RS', 'AGN', 'CUR', 'ACCT', 'BN', 'BL','PM', 'BAC', 'BACNO', 'CC', 'MIDPT', 'MXDPT', 'TDL', 'ADA', 'MIWPT', 'MXWPT', 'MXWPD', 'IURL'],
                reportHeaders: [],
                needResetHeaders: false,
                maxWithdrawAmount: 50000,
                minWithdrawAmount: 10,
                dd_pm: [],
                bool_isDDMV: false,
                currencySymbol: '',
            }
        },
        validations: {
            obj_bankacc: {
                BI: { required },
                BA: { required },
                BAN: { required },
                CI: { required },
                Add_AB: {
                    required: requiredIf(function (vm) {
                        return (this.bool_isAAB == true && vm.Add_AB != 0) || (this.bool_isAAB == true && vm.Add_AB > vm.AB)
                    }),
                },
                AT: { required },
                AGIT: { required },
                CC: { required },
                PLURL: {
                    maxLength: value => !value || maxLength(300)(value), validateUrl
                },
                // AMAXW: { decimal },
                // AWDM: { numeric },
                // AWM: { numeric },

                BP: {
                    required: requiredIf(function (vm) {
                        return (vm.I == 0 && vm.BU != "") || (vm.BPC != '' && vm.BPC != null);
                    }),
                },
                BPC: {
                    sameAsPassword: sameAs(function (vm) { return (vm.I == 0 && vm.BU != "") || (vm.BP != '' && vm.BP != null) ? vm.BP : vm.BPC; })
                },
                BU: {
                    required: requiredIf(function (vm) {
                        return vm.IA != null && (vm.IA == 1 || vm.IA == 2);
                    }),
                },
                BICN: {
                    required: requiredIf(function (vm) {
                        return vm.IA != null && (vm.IA == 11 || vm.IA == 12);
                    }),
                },
                BDOB: {
                    required: requiredIf(function (vm) {
                        return vm.IA != null && (vm.IA == 11 || vm.IA == 12);
                    }),
                },
                BMN: {
                    required: requiredIf(function (vm) {
                        return vm.IA != null && (vm.IA == 11 || vm.IA == 12);
                    }),
                },
                BAPIN: {
                    required: requiredIf(function (vm) {
                        return vm.IA != null && (vm.IA == 11 || vm.IA == 12);
                    }),
                },
                BCT: {
                    required: requiredIf(function (vm) {
                        return vm.IA != null && (vm.IA == 11 || vm.IA == 12);
                    }),
                },
                BDI: {
                    required: requiredIf(function (vm) {
                        return vm.IA != null && (vm.IA == 11 || vm.IA == 12);
                    }),
                },
                MTV: {
                    required: requiredIf(function (vm) {
                        return vm.VIPBA;
                    })
                },
                FCS: {
                    required: requiredIf(function (vm) {
                        return this.bool_obj_bankaccDC;
                        //return vm.ER != null && vm.ER != 1;
                    })
                },
                ER: {
                    required: requiredIf(function (vm) {
                        return this.bool_obj_bankaccDC;
                        //return vm.FCS != null && vm.FCS != "";
                    })
                },
                TCS: {
                    required: requiredIf(function (vm) {
                        return this.bool_obj_bankaccDC;
                        //return vm.ER != null && vm.ER != 1;
                    })
                },
                TER: {
                    required: requiredIf(function (vm) {
                        return this.bool_obj_bankaccDC;
                        //return vm.FCS != null && vm.FCS != "";
                    })
                }
            },
            obj_bankAD: {
                BICN: { required },
                BDOB: { required },
                BMN: { required },
                BAPIN: { required },
                BCT: { required },
                BCC: {
                    required: requiredIf(function (vm) {
                        return vm.BCT == "P8";
                    }),
                },
                OTP: {
                    required: requiredIf(function (vm) {
                        return this.int_obj_autoDepositAppStep == 1;
                    })
                }
            },
            obj_bankADWithdraw: {
                recBAN: { required },
                recBC: { required },
                TA: { required, decimal, minValue: minValue(10), maxValue: maxValue(50000) },
                BAPIN: { required }
            },
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
            ...mapGetters('CurrencyInfo', ['getThousandCurrency']),
            IsADBAutoWithdrawModule() {
                return constADBBankList.indexOf(this.str_autoDepositCode || this.obj_bankacc.ADC) >= 0 && (this.obj_bankacc.AT == '0' || this.obj_bankacc.AT == '2')
            },
            IsADBAutoDepositModule() {
                return constADBDepoBankList.indexOf(this.str_autoDepositCode || this.obj_bankacc.ADC) >= 0 && (this.obj_bankacc.AT == '1' || this.obj_bankacc.AT == '2')
            }
        },
        methods: {
            ...mapActions('CurrencyInfo', ['setThousandCurrency']),
            copyLink() {
                var inp = document.createElement('input');
                document.body.appendChild(inp)
                inp.value = "https://crm.afb.gg/smsq/smsq-1.4.4.apk";
                inp.select();
                document.execCommand('copy', false);
                inp.remove();
            },
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[13].FV.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.str_FV[13].FV.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[13].FV.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.str_FV[13].FV.endDate = "";
                    }
                }

                if (type == "BDOB") {
                    if (event != "") {
                        var momentObj = moment(event, 'DD MMM YYYY');
                        var dateObj = new Date(momentObj);
                        if (dateObj != "Invalid Date") {
                            this.obj_bankAD.BDOB = momentObj.format("YYYY-MM-DD");
                        }
                        else {
                            this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["BAL"]["BDOB"]), 1000);
                        }
                    } else {
                        this.obj_bankAD.BDOB = "";
                    }
                }
            },
            closeAdd() {
                this.selectedFile = null;
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_isADAPP = false;
                this.bool_CV = false;
                this.bool_ADCV = false;
            },
            closeAdd1() {
                this.previewUrl = null;
                this.bool_fullPreview = !this.bool_fullPreview;
            },
            closeAddBankAccount() {
                this.bool_isAAB = !this.bool_isAAB;
                this.Add_AB = null;
                this.bool_CV = false;
                this.bool_ADCV = false;
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('ACL', 'B', type);
            },
            checkBankAccountIsAuto(isAuto) {
                return isAuto == 2 || isAuto == 11 || isAuto == 12;
            },
            checkSCBAPPIsAuto(isAuto) {
                return isAuto == 11 || isAuto == 12;
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            checkStatus(RS) {
                var a = this.$parent.checkStatus(RS);
                if (a) {
                    return "Active";
                } else {
                    return "Inactive";
                }
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getBankAccountList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getBankAccountList();
                }
            },
            getCountryCode() {
                this.dd_cc = constCountryCode;
            },
            AgentGroupChangefs(value) {

                if (value != undefined) {
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                        this.searchPAgi = agi;
                    } else {
                        this.searchPAgi = 0;
                    }
                } else {
                    this.searchPAgi = 0;
                    this.str_FV[11].FV = null;
                }
                this.str_FV[1].FV = null;
                this.dd_currency_s = null;
                this.getCurrencyList();
            },
            CountryCodeChange(value) {
                if (this.obj_bankacc['I'] == 0) {
                    this.obj_bankacc.BI = null;
                }
                var that = this;
                var cc = value;
                this.getDataApi(`/api/dd/allbank/` + cc,
                    function (d, s) {
                        if (s) {
                            that.dd_bank = d.dropdownlist

                            if (that.obj_bankacc.I > 0) {
                                that.BankChange(that.obj_bankacc.BI);
                            }
                        }
                    });
            },
            CurrencyChange(value) {
                if (value != undefined) {
                    var that = this;
                    this.dd_currency.find(function (val, idx) {
                        if (val.id == value) {
                            that.setThousandCurrency(that.CheckIsThousandCurrency(val.label, that), that);
                            that.currencySymbol = val.label;
                            if (!that.obj_bankacc['TCS']) {
                                that.obj_bankacc['TCS'] = val.label;
                            }
                        }
                    });
                } else {
                    this.obj_bankacc['FCS'] = "";
                    this.obj_bankacc['TCS'] = "";
                    this.obj_bankacc['ER'] = 1;
                    this.obj_bankacc['TER'] = 1;
                }
            },
            AgentGroupChange(value) {
                this.ddEditMemberTypeList = [];
                var that = this;
                var agi = 0;

                if (value) {
                    agi = value.split("-")[1];
                }
                this.getDataApi(`/api/dd/cur/` + agi,
                    function (d, s) {
                        if (s) {
                            that.dd_currency = d.dropdownlist;
                            if (that.obj_bankacc.I > 0) {
                                that.CurrencyChange(that.obj_bankacc.CI);
                            }
                        }
                    });
                this.getDataApi(`/api/dd/mType/` + agi,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddEditMemberTypeList = d.dropdownlist;
                        }
                    });
            },
            ChangeAT(value) {
                switch (value) {
                    case '0':
                        this.str_FV[2].FV = 1
                        this.str_FV[3].FV = 0
                        break;
                    case '1':
                        this.str_FV[2].FV = 0
                        this.str_FV[3].FV = 1
                        break;
                    case '2':
                        this.str_FV[2].FV = 1
                        this.str_FV[3].FV = 1
                        break;
                    default:
                        this.str_FV[2].FV = ""
                        this.str_FV[3].FV = ""
                        break;
                }
            },

            getDropdownList() {
                var that = this;
                this.bool_fullLoading = true;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);
                            if (that.dd_agentgroupfs.length > 0) {
                                that.dd_agentgroupfs.forEach(that.disableAgentGroupParent);
                            }

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);
                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI );
                            }
                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
            },
            getCurrencyList() {
                var that = this;
                var agi = 0;
                if (this.searchPAgi) {
                    agi = this.searchPAgi;
                }
                this.getDataApi(`/api/dd/currency/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency_s = d.dropdownlist
                            that.bool_fullLoading = false;
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            getBankAccountList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                temp_ += this.str_FV[i].FV[x];
                            }
                            path += ("f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        else if (this.str_FV[i].F == 'CTS' && this.str_FV[i].FV != '') {
                            if (this.str_FV[i].FV.startDate != "") {
                                var cts_from = this.parseDateToJsonString(this.str_FV[i].FV.startDate);
                                path += "&f[CTS_from]=" + cts_from;
                            }
                            if (this.str_FV[i].FV.endDate != "") {
                                var cts_to = this.parseDateToJsonString(this.str_FV[i].FV.endDate);
                                path += "&f[CTS_to]=" + cts_to;
                            }
                        }
                        else if (this.str_FV[i].F == 'agi' && this.str_FV[i].FV != '') {
                            var agi = 0;
                            var value = this.str_FV[i].FV;
                            if (value != "") {
                                agi = value.split("-")[1];
                            }
                            path += "f[agi]=" + agi;

                        }
                        else {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };
                this.getDataApi(`/api/bankacc/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setBankAccountList(d.D);
                            that.resizeTableHead();
                        }
                    });
            },
            setBankAccountList(data) {   // this out put at BankAccount.js and this output after get list
                this.arry_lcl = data.Items;                                
                this.int_TP = Math.max(data.TotalPages, 1);
                this.int_TI = data.TotalItems;
            },
            addBankAccount() {
                this.obj_bankacc = {
                    I: 0,
                    RS: 1,
                    VIPBA: false,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    AT: null,
                    BI: null,
                    BA: "",
                    BAN: "",
                    CI: null,
                    Add_AB: null,
                    AB: null,
                    MINW: null,
                    MAXW: null,
                    MIND: null,
                    MAXD: null,
                    TD: null,
                    TUD: null,
                    TW: null,
                    AGI: null,
                    ID: null,
                    IW: null,
                    AGIT: null,
                    CC: null,
                    BU: "",
                    BP: "",
                    BPC: "",
                    IA: null,
                    ADS: "",
                    ADR: "",
                    LPUTS: null,
                    IUT: false,
                    QRCI: "",
                    MT: [],
                    MTV: [],
                    EAW:false, //EnableAutoWithdrawal
                    AMAXW:0,  //AutoMAXWithdrawal
                    AWDM:0,  //AutoWDepositMultiplier
                    AWM:15,  //AutoWithdrawalMinutes
                    BICN: "",
                    BDOB: "",
                    ISDL: 0,
                    BMN: "",
                    BAPIN: "",
                    BDI: "",
                    BCT: null,
                    FCS: "",
                    ER: 1,
                    TCS: "",
                    TER: 1,
                    PM: [],
                    HBI:false
                };

                this.obj_bankAD = {
                    BICN: "",
                    BCT: "P1",
                    BDOBpicker: { startDate: '' },
                    BDOB: "",
                    BMN: "",
                    BAPIN: "",

                    OTP: "",
                    APIAuth: "",
                    Token: ""
                };
                this.bool_CV = false;
                this.bool_ADCV = false;
                this.bool_isAMV = true;
                this.bool_isADAPP = false;
                this.bool_isD = false;
                this.bool_isW = false;
                this.bool_isAutoDepositBank = 0;
                this.bool_obj_bankaccRS = true;
                this.bool_obj_bankaccDC = false;
                this.bool_obj_isAutoDeposit = 0;
                this.newImg = false;

                if (this.dd_agentgroup[0].children == undefined) {
                    var at = 0;
                    at = this.dd_agentgroup[0].id.split("-")[0];
                    if (at == 3 && this.dd_agentgroup.length < 2) {
                        this.obj_bankacc.AGIT = this.dd_agentgroup[0].id;
                        this.AgentGroupChange(this.obj_bankacc.AGIT);
                    }
                }

            },
            checkMinMax(type) {
                if (type == 1) {
                    if (this.obj_bankacc.MIND != 0 && this.obj_bankacc.MAXD != 0) {
                        if (parseFloat(this.obj_bankacc.MIND) > parseFloat(this.obj_bankacc.MAXD)) {
                            return this.getLanguage['BAL']['MINDERR'];
                        }
                    }
                    else {
                        return "";
                    }
                }
                else if (type == 2) {
                    if (this.obj_bankacc.MINW != 0 && this.obj_bankacc.MAXW != 0) {
                        if (parseFloat(this.obj_bankacc.MINW) > parseFloat(this.obj_bankacc.MAXW)) {
                            return this.getLanguage['BAL']['MINWERR'];
                        }
                    }
                    else {
                        return "";
                    }
                }
            },
            addAccountBalance(id) {
                this.bool_fullLoading = true;
                var that = this;

                this.getDataApi(`/api/bankacc/g/${id}`,
                    function (d, s) {
                        if (s) {
                            that.obj_bankacc = Object.assign(that.obj_bankacc, d.D);
                            that.setThousandCurrency(that.CheckIsThousandCurrency(that.obj_bankacc.CS, that), that);
                            that.bool_isAAB = true;
                        }
                        that.bool_fullLoading = false;
                    });
            },
            bankStatementList(agi, bai) {
                this.$router.push("/B/BankStatement?agi=" + agi + "&bai=" + bai);
            },
            triggerPullStatement(bankAcc) {
                var that = this;

                if (bankAcc) {
                    this.$fire({
                        title: this.getLanguage["BTN"]["PBS"],
                        html: "[" + bankAcc.BN + "] " + bankAcc.BA + "(" + bankAcc.BAN + ")",
                        width: '30em',
                        showCancelButton: true,
                        confirmButtonText: this.getLanguage["GL"]["YES"],
                        cancelButtonText: this.getLanguage["CNO"]["NO"],
                        reverseButtons: true,
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    }).then((result) => {
                        if (result.value == true) {
                            that.bool_fullLoading = true;

                            this.postDataApi(`/api/bankacc/pbs`, bankAcc,
                                function (d, s) {
                                    that.bool_fullLoading = false;

                                    if (s) {
                                        that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("MSG.BSS"));
                                    }
                                });
                        }
                    });
                }
            },
            editBankAccount(id) {
                this.bool_fullLoading = true;
                var that = this;
                this.newImg = false;
                this.getDataApi(`/api/bankacc/g/${id}`,
                    function (d, s) {
                        if (s) {

                            that.setBankAccount(d.D);

                            that.bool_isAMV = true;
                            if (that.obj_bankacc.AGI != 0) {
                                that.obj_bankacc.AGIT = "3-" + that.obj_bankacc.AGI;
                                that.AgentGroupChange(that.obj_bankacc.AGIT);
                                that.CountryCodeChange(that.obj_bankacc.CC);
                            }
                            that.obj_bankacc.IUT = false;
                        }

                        that.bool_fullLoading = false;
                    });
            },
            setBankAccount(data) {
                this.obj_bankacc = Object.assign(this.obj_bankacc, data);
                this.obj_bankacc.AT = this.setAT(data.ID, data.IW);
                this.bool_isAMV = true;
                this.bool_obj_bankaccRS = this.returnStatus();

                this.bool_obj_bankaccDC = data.FCS != null && data.FCS != "";

                //this.bool_obj_bankaccVIP = this.obj_bankacc["VIPBA"] == 1 ? true : false;
                //this.obj_bankacc.BP = "";
                this.obj_bankacc.BPC = "";

                if (this.obj_bankacc.BP != "")
                    this.obj_bankacc.BPC = this.obj_bankacc.BP;

                this.bool_obj_isAutoDeposit = this.obj_bankacc["IA"];
                this.generateDepositType(this.obj_bankacc.IA);
                if (this.obj_bankacc.IA == 0) {
                    this.obj_bankacc.IA = null;
                }
                if (this.obj_bankacc.MT != null && this.obj_bankacc.MT != '') {
                    this.obj_bankacc.MTV = this.obj_bankacc.MT.split(',');
                } else {
                    this.obj_bankacc.MTV = [];
                }
            },
            returnStatus() {
                if (this.obj_bankacc["RS"] == 2) {
                    return true;
                } else {
                    return false;
                }
            },
            ValidationErrMsg(value, langKey = "") {
                if (this.bool_CV) {

                    var validateObj = this.$v.obj_bankacc[value];
                    
                    if (validateObj.required != undefined && !validateObj.required) {
                        if (value == 'MTV')
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MEM"][langKey]);
                        else
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["BAL"][langKey]);
                    }
                    else if (validateObj.alphaNum != undefined && !validateObj.alphaNum) {
                        return String.format(this.getLanguage['ERR']['1008'], this.getLanguage['BAL']['BANO']);

                    }
                    else if (validateObj.sameAsPassword != undefined && !validateObj.sameAsPassword) {
                        return this.getLanguage['ERR']['3001'];
                    } else if (validateObj.maxLength != undefined && !validateObj.maxLength) {
                        return this.getLanguage['PV']['URLERORL'];
                    } else if (validateObj.validateUrl != undefined && !validateObj.validateUrl) {
                        return this.getLanguage['PV']['IURLF'];
                    }
                }
            },
            ValidationErrMsgAD(value, langKey = "") {
                if (this.bool_ADCV) {
                    var validateADObj = this.$v.obj_bankAD[value];

                    if (validateADObj.required != undefined && !validateADObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["BAL"][langKey]);
                    }
                }
            },
            ValidationErrMsgADWithdraw(value, langKey = "") {
                if (this.bool_ADWitdrawCV) {
                    var validateADObj = this.$v.obj_bankADWithdraw[value];

                    if (validateADObj.required != undefined && !validateADObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["BAL"][langKey]);
                    }
                    else if (validateADObj.numeric != undefined && !validateADObj.numeric) {
                        return String.format(this.utilGetErrorLanguage('1009'), this.getLanguage["BAL"][langKey]);
                    }
                    else if (validateADObj.minValue != undefined && !validateADObj.minValue) {
                        let minWithdraw = this.ThousandSeparator(this.minWithdrawAmount, this.getThousandCurrency ? 3 : 2)
                        return String.format(this.utilGetErrorLanguage('1033'), this.getLanguage["BAL"][langKey], minWithdraw);
                    }
                    else if (validateADObj.maxValue != undefined && !validateADObj.maxValue) {
                        let maxWithdraw = this.ThousandSeparator(this.maxWithdrawAmount, this.getThousandCurrency ? 3 : 2)
                        return String.format(this.utilGetErrorLanguage('1034'), this.getLanguage["BAL"][langKey], maxWithdraw);
                    }
                }
            },
            triggerWithdraw(value) {
                var that = this;

                this.bool_ADWitdrawCV = false;
                this.bool_fullLoading = true;
                this.int_obj_autoDepositWithdrawStep = 0;

                this.str_autoDepositWithdrawErrMsg = "";
                this.obj_bankADWithdraw = {
                    sBAI: value.I,
                    sBA: value.BA,
                    sBAN: value.BAN,
                    sBAL: 0,
                    recBAN: "",
                    recBC: null,
                    TA: null,
                    BAPIN: "",
                    recAccTo: "",
                    recAccToDN: ""
                };


                let adGetBalanceObj = {};
                adGetBalanceObj["BAI"] = value.I;
                adGetBalanceObj["IA"] = value.IA;

                this.postDataApi(`/api/bankacc/adgb`, adGetBalanceObj,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s && d.result) {
                            that.bool_isADAPPWithdraw = true;
                            that.obj_bankADWithdraw.sBAL = d.totalAvailableBalance;

                            if (d.totalAvailableBalance - that.minWithdrawAmount < 50000)
                                that.maxWithdrawAmount = d.totalAvailableBalance - that.minWithdrawAmount;
                        }
                        else {
                            that.showErrorMessage(null, that.utilGetErrorLanguage('8051'), 1000);
                        }
                    });


            },
            closeAccountWithdrawal() {
                this.bool_isADAPPWithdraw = false;
                this.bool_ADWitdrawCV = false;

                this.str_autoDepositWithdrawErrMsg = "";
                this.int_obj_autoDepositWithdrawStep = 0;

                this.obj_bankADWithdraw = {
                    sBAI: 0,
                    sBA: "",
                    sBAN: "",
                    sBAL: 0,
                    recBAN: "",
                    recBC: null,
                    TA: null,
                    BAPIN: "",
                    recAccTo: "",
                    recAccToDN: ""
                };

            },
            AutoDepositWithdraw() {
                var that = this;

                this.str_autoDepositWithdrawErrMsg = "";
                this.bool_ADWitdrawCV = true;
                this.$v.obj_bankADWithdraw.$touch();

                if (!this.$v.obj_bankADWithdraw.$error) {
                    this.bool_fullLoading = true;

                    let adTObj = {};
                    adTObj["BAI"] = this.obj_bankADWithdraw.sBAI;
                    adTObj["recBAN"] = this.obj_bankADWithdraw.recBAN;
                    adTObj["recBC"] = this.obj_bankADWithdraw.recBC;
                    adTObj["TA"] = this.obj_bankADWithdraw.TA;
                    adTObj["BAPIN"] = this.obj_bankADWithdraw.BAPIN;

                    this.postDataApi(`/api/bankacc/advt`, adTObj,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_ADWitdrawCV = false;

                            if (s && d.result) {
                                that.int_obj_autoDepositWithdrawStep = 1;

                                that.obj_bankADWithdraw.recAccTo = d.accountTo;
                                that.obj_bankADWithdraw.recAccToDN = d.accountToDisplayName;
                            }
                            else {
                                that.int_obj_autoDepositWithdrawStep = 0;

                                if (d.systemError != null && d.systemError != "") {
                                    that.str_autoDepositWithdrawErrMsg = that.utilGetErrorLanguage(d.systemError);
                                }
                                else {
                                    that.str_autoDepositWithdrawErrMsg = d.error;
                                }
                            }
                        });
                }
            },
            AutoDepositConfirmWithdraw() {
                var that = this;

                let adTObj = {};
                adTObj["BAI"] = this.obj_bankADWithdraw.sBAI;
                adTObj["recBAN"] = this.obj_bankADWithdraw.recBAN;
                adTObj["recBC"] = this.obj_bankADWithdraw.recBC;
                adTObj["TA"] = this.obj_bankADWithdraw.TA;

                this.postDataApi(`/api/bankacc/adct`, adTObj,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s && d.result) {
                            that.int_obj_autoDepositWithdrawStep = 0;
                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.WIS"));

                            that.closeAccountWithdrawal();
                        }
                        else {
                            that.int_obj_autoDepositWithdrawStep = 1;
                            that.str_autoDepositWithdrawErrMsg = "[" + d.completedStepNo + "] " + d.err;
                        }
                    });
            },
            AutoDepositWithdrawError() {
                return this.str_autoDepositWithdrawErrMsg;
            },
            getADDOB() {
                if (this.obj_bankacc.BDOB != null && this.obj_bankacc.BDOB != "") {
                    let momentObj = moment(this.obj_bankacc.BDOB, "YYYY-MM-DD");

                    return momentObj.format("DD MMM YYYY");
                }

                return "";
            },
            AutoDepositSetupError() {
                return this.str_autoDepositErrMsg;
            },
            setupAutoDepositAPP() {
                this.obj_bankAD = {
                    BICN: "",
                    BCT: "P1",
                    BDOBpicker: { startDate: '' },
                    BDOB: "",
                    BMN: "",
                    BAPIN: "",

                    OTP: "",
                    APIAuth: "",
                    Token: "",
                };
                this.bool_isADAPP = true;
                this.str_autoDepositErrMsg = "";
            },
            closeSetupBankAccount() {
                this.bool_isADAPP = false;
                this.bool_CV = false;
                this.bool_ADCV = false;
                this.str_autoDepositErrMsg = "";
                this.int_obj_autoDepositAppStep = 0;
            },
            backAutoDepositStep1() {
                this.int_obj_autoDepositAppStep = 0;
            },
            autoDepositStep1() {
                this.str_autoDepositErrMsg = "";
                this.bool_ADCV = true;
                this.bool_fullLoading = true;

                if (this.obj_bankAD.BDOBpicker.startDate != null) {
                    var momentObj = moment(this.obj_bankAD.BDOBpicker.startDate, 'DD MMM YYYY');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date") {
                        this.obj_bankAD.BDOB = momentObj.format("YYYY-MM-DD");
                    }
                }

                this.$v.obj_bankAD.$touch();
                if (!this.$v.obj_bankAD.$error) {
                    let autoDepositStep1Obj = {};
                    autoDepositStep1Obj["ADCODE"] = this.str_autoDepositCode;
                    autoDepositStep1Obj["BCT"] = this.obj_bankAD.BCT;

                    if (this.obj_bankAD.BCT == "P8") {
                        if (this.obj_bankAD.BICN != null && this.obj_bankAD.BICN.length > 0 && this.obj_bankAD.BCC != null && this.obj_bankAD.BCC.length > 0) {
                            autoDepositStep1Obj["BICN"] = this.obj_bankAD.BCC.toUpperCase() + this.obj_bankAD.BICN;
                        }
                    }
                    else {
                        if (this.obj_bankAD.BICN != null && this.obj_bankAD.BICN.length > 0) {
                            autoDepositStep1Obj["BICN"] = this.obj_bankAD.BICN;
                        }
                    }

                    if (this.obj_bankAD.BDOB != null && this.obj_bankAD.BDOB.length > 0) {
                        autoDepositStep1Obj["BDOB"] = this.obj_bankAD.BDOB;
                    }

                    if (this.obj_bankAD.BMN != null && this.obj_bankAD.BMN.length > 0) {
                        autoDepositStep1Obj["BMN"] = this.obj_bankAD.BMN;
                    }

                    if (this.obj_bankAD.BAPIN != null && this.obj_bankAD.BAPIN.length > 0) {
                        autoDepositStep1Obj["BAPIN"] = this.obj_bankAD.BAPIN;
                    }

                    var that = this;
                    this.postDataApi(`/api/bankacc/ads1`, autoDepositStep1Obj,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_ADCV = false;

                            if (s && d.success) {
                                that.int_obj_autoDepositAppStep = 1;
                                that.obj_bankAD.APIAuth = d.apiAuth;
                                that.obj_bankAD.Token = d.tokenUUID;
                            }
                            else {
                                that.int_obj_autoDepositAppStep = 0;
                                that.str_autoDepositErrMsg = "[" + d.completedStepNo + "] " + d.err;
                            }
                        });
                }
                else {
                    this.bool_fullLoading = false;
                }
            },
            autoDepositStep2() {
                this.str_autoDepositErrMsg = "";
                this.bool_ADCV = true;
                this.bool_fullLoading = true;

                this.$v.obj_bankAD.$touch();
                if (!this.$v.obj_bankAD.$error)
                {
                    let autoDepositStep2Obj = {};
                    autoDepositStep2Obj["ADCODE"] = this.str_autoDepositCode;

                    if (this.obj_bankAD.BCT == "P8") {
                        if (this.obj_bankAD.BICN != null && this.obj_bankAD.BICN.length > 0 && this.obj_bankAD.BCC != null && this.obj_bankAD.BCC.length > 0) {
                            autoDepositStep2Obj["BICN"] = this.obj_bankAD.BCC.toUpperCase() + this.obj_bankAD.BICN;
                        }
                    }
                    else {
                        if (this.obj_bankAD.BICN != null && this.obj_bankAD.BICN.length > 0) {
                            autoDepositStep2Obj["BICN"] = this.obj_bankAD.BICN;
                        }
                    }

                    if (this.obj_bankAD.BDOB != null && this.obj_bankAD.BDOB.length > 0) {
                        autoDepositStep2Obj["BDOB"] = this.obj_bankAD.BDOB;
                    }

                    if (this.obj_bankAD.BMN != null && this.obj_bankAD.BMN.length > 0) {
                        autoDepositStep2Obj["BMN"] = this.obj_bankAD.BMN;
                    }

                    if (this.obj_bankAD.BAPIN != null && this.obj_bankAD.BAPIN.length > 0) {
                        autoDepositStep2Obj["BAPIN"] = this.obj_bankAD.BAPIN;
                    }

                    autoDepositStep2Obj["BOTP"] = this.obj_bankAD.OTP;
                    autoDepositStep2Obj["BAPIAUTH"] = this.obj_bankAD.APIAuth;
                    autoDepositStep2Obj["BTOKEN"] = this.obj_bankAD.Token;

                    var that = this;
                    this.postDataApi(`/api/bankacc/ads2`, autoDepositStep2Obj,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_ADCV = false;

                            if (s && d.success) {
                                that.int_obj_autoDepositAppStep = 0;
                                that.obj_bankacc.BDI = d.deviceId;

                                that.obj_bankacc.BCT = that.obj_bankAD.BCT;
                                that.obj_bankacc.BICN = that.obj_bankAD.BICN;
                                that.obj_bankacc.BDOB = that.obj_bankAD.BDOB;
                                that.obj_bankacc.BMN = that.obj_bankAD.BMN;
                                that.obj_bankacc.BAPIN = that.obj_bankAD.BAPIN;

                                that.bool_isADAPP = false;
                            }
                            else {
                                that.int_obj_autoDepositAppStep = 1;
                                that.str_autoDepositErrMsg = "[" + d.completedStepNo + "] " + d.err;
                            }
                        });
                }
                else {
                    this.bool_fullLoading = false;
                }
            },
            SCBCardTypeChange(value) {
                if (value == "P8") {
                    this.bool_showSCBPassportCountry = true;
                }
                else {
                    this.bool_showSCBPassportCountry = false;
                }
            },
            saveBankAccountBalance(value) {
                this.bool_CV = true;
                var checkSave = false;
                var ab = this.obj_bankacc.AB;
                var result = 0;
                var adjustAmount = parseFloat(this.obj_bankacc.Add_AB);

                if (value == "m") {
                    if (adjustAmount <= ab && adjustAmount > 0) {
                        checkSave = true;
                        this.obj_bankacc.TT = 2;
                        result = ab - adjustAmount

                    }
                }
                else if (value == "p") {
                    if (adjustAmount > 0) {
                        checkSave = true;
                        this.obj_bankacc.TT = 1;
                        result = ab + adjustAmount

                    }
                }

                this.obj_bankacc.UDB = true;
                this.$v.obj_bankacc.$touch();
                if (checkSave) {
                    this.obj_bankacc.AB = result;
                    var that = this;
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    this.postDataApi(`/api/bankacc/s`, this.obj_bankacc,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.bool_isAAB = false;
                                that.obj_bankacc.Add_AB = null;
                                that.getBankAccountList();
                            }
                        });
                }
                else {
                    this.$v.obj_bankacc.$error;
                }
            },
            saveBankAccount() {
                this.bool_CV = true;
                this.bool_errminmax = false;

                if (this.obj_bankacc.MIND != 0 && this.obj_bankacc.MIND != null && this.obj_bankacc.MAXD != 0 && this.obj_bankacc.MAXD != null) {
                    if (parseFloat(this.obj_bankacc.MIND) < parseFloat(this.obj_bankacc.MAXD)) {
                        this.bool_errminmax = true;
                    }
                    else {
                        this.bool_errminmax = false;
                    }
                } else {
                    this.bool_errminmax = true;
                }

                if (this.obj_bankacc.MINW != 0 && this.obj_bankacc.MINW != null && this.obj_bankacc.MAXW != 0 && this.obj_bankacc.MAXW != null) {
                    if (parseFloat(this.obj_bankacc.MINW) < parseFloat(this.obj_bankacc.MAXW)) {
                        this.bool_errminmax = true;
                    }
                    else {
                        this.bool_errminmax = false;
                    }
                } else {
                    this.bool_errminmax = true;
                }
                this.obj_bankacc.BAN = this.obj_bankacc.BAN.replaceAll(' ', '');
                //this.obj_bankacc.BAN = this.obj_bankacc.BAN.replace(/[^0-9a-z]/gi, ''); // TT2791 remove nonAlphaNum and whitespace before saving
                var iurlTab = this.getIURLTabIndex();
                if (iurlTab != 1) { // external img url
                    if (this.obj_bankacc.QRCI != null && this.obj_bankacc.QRCI != "") {
                        //if img url is not empty
                        this.obj_bankacc.IUT = true;
                        this.newImg = true;
                    }
                }
                this.obj_bankacc.UDB = false;
                this.$v.obj_bankacc.$touch();
                if (!this.$v.obj_bankacc.$error && this.bool_errminmax) {
                    var agi = this.obj_bankacc.AGIT.split("-");

                    this.obj_bankacc.AGI = agi[1];
                    this.obj_bankacc.MT = '';
                    if (this.obj_bankacc.MTV && this.obj_bankacc.MTV.length > 0 && this.obj_bankacc.VIPBA) {
                        this.obj_bankacc.MT = this.obj_bankacc.MTV.join(',');
                    }
                    var that = this;
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    this.obj_bankacc.ID = this.obj_bankacc.ID == 1 ? true : false;
                    this.obj_bankacc.IW = this.obj_bankacc.IW == 1 ? true : false;

                    //if different currency checkbox unchecked, clear FCS to be null
                    if (!this.bool_obj_bankaccDC) {
                        this.obj_bankacc.FCS = null;
                        this.obj_bankacc.TCS = null;
                    }

                    //this.obj_bankacc.IA = this.obj_bankacc.IA == null ? 0 : this.obj_bankacc.IA;
                    if (this.newImg == true) {
                        this.obj_bankacc['QRCodeImage'] = this.selectedFile;
                        this.postDataApiWithAttach(`/api/bankacc/s`, this.obj_bankacc,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                that.bool_fullScreen = false;
                                if (s) {
                                    that.bool_isAMV = false;
                                    that.selectedFile = null;
                                    that.getBankAccountList();
                                }
                            });
                    } else {
                        this.postDataApi(`/api/bankacc/s`, this.obj_bankacc,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.bool_isAMV = false;
                                    that.selectedFile = null;
                                    that.getBankAccountList();
                                }
                            });
                    }
                } else {
                    //get the object for validating.
                    const validation = this.$v["obj_bankacc"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            saveBankAccountStatus(data, status) {
                this.bool_fullLoading = true;
                this.bool_fullScreen = true;

                this.obj_bankacc = data;
                this.obj_bankacc.RS = status;

                var that = this;

                var obj = {
                    i: data.I,
                    uts: data.UTS,
                    rs: status
                };

                this.postDataApi(`/api/bankacc/t`, obj,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        that.bool_fullScreen = false;
                        if (s) {
                            that.getBankAccountList();
                        }
                    });
            },
            removeBankAccount(aRow) { //remove
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var obj = {
                            i: aRow.I,
                            uts: aRow.UTS
                        };

                        this.postDataApi(`/api/bankacc/d`, obj,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.getBankAccountList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            confirmreset(dataI, dataTud, dataAgi) {
                this.$fire({
                    title: this.getLanguage["BTN"]["BTNRESET"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var obj = {
                            i: dataI,
                            tud: dataTud,
                            AGI: dataAgi
                        };
                        this.postDataApi(`/api/bankacc/cr`, obj,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.getBankAccountList();
                                    that.editBankAccount(dataI);
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            setAT_add(value) {
                if (value == "0") { //with
                    this.bool_isW = true;
                    this.bool_isD = false;
                    this.obj_bankacc.MIND = 0
                    this.obj_bankacc.MAXD = 0
                    // this.obj_bankacc.TD = 0
                    this.obj_bankacc.ID = 0
                    this.obj_bankacc.IW = 1
                } else if (value == "1") { // deposit
                    this.bool_isW = false;
                    this.bool_isD = true;
                    this.obj_bankacc.MINW = 0
                    this.obj_bankacc.MAXW = 0
                    this.obj_bankacc.TW = 0
                    this.obj_bankacc.ID = 1
                    this.obj_bankacc.IW = 0
                } else if (value == "2") {
                    this.bool_isW = true;
                    this.bool_isD = true;
                    this.obj_bankacc.MINW = 0
                    this.obj_bankacc.MAXW = 0
                    this.obj_bankacc.TW = 0
                    this.obj_bankacc.MIND = 0
                    this.obj_bankacc.MAXD = 0
                    // this.obj_bankacc.TD = 0
                    this.obj_bankacc.IW = 1
                    this.obj_bankacc.ID = 1
                }
                this.BankChange(this.obj_bankacc.BI);
            },
            setAT(ID, IW) {
                if (ID == 1 && IW == 1) {
                    return "2";
                } else if (ID == 1) {
                    return "1";
                } else if (IW == 1) {
                    return "0";
                } else {
                    return undefined;
                }
            },
            checkAT(ID, IW) {
                if (ID == 1 && IW == 1) {
                    return this.getLanguage['MTA']['DNW'];
                } else if (ID == 1) {
                    return this.getLanguage['ACO']['AD3P'];
                } else if (IW == 1) {
                    return this.getLanguage['CTS']['TTW'];
                } else {
                    return this.getLanguage['ACL']['NAT'];
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            ConvertCountryCode(value) {
                var text = '';
                for (var i = 0; i < this.dd_cc.length; i++) {
                    for (var x = 0; x < this.dd_cc[i].children.length; x++) {
                        if (this.dd_cc[i].children[x].id == value) {
                            text = this.dd_cc[i].children[x].label;
                        }
                    }
                }
                return text;
            },
            clearDateRangeFilter() {
                this.str_FV[13].FV = {
                    startDate: "",
                    endDate: ""
                };
            },

            BankChange(value) {
                let isAutoDepositBank = 0;
                this.str_autoDepositCode = "";
                if (this.dd_bank != null && this.dd_bank.length > 0) {
                    for (var i = 0; i < this.dd_bank.length; i++) {
                        if (this.dd_bank[i].id == value && this.dd_bank[i].extra != "") {
                            isAutoDepositBank = parseInt(this.dd_bank[i].extra);

                            if (isAutoDepositBank > 0) {
                                this.str_autoDepositCode = this.dd_bank[i].extraCat;
                            }

                            break;
                        }
                    }
                }

                this.dd_adty = [];

                if (this.obj_bankacc["AT"] == 1 || this.obj_bankacc["AT"] == 2) {
                    this.bool_isAutoDepositBank = isAutoDepositBank;

                    switch (this.bool_isAutoDepositBank) {
                        case 1:
                            this.dd_adty.push(constAutoDepositType[0]);

                            if (this.str_autoDepositCode != "" && this.str_autoDepositCode in constAutoDepositBankApp) {
                                this.dd_adty.push(constAutoDepositBankApp[this.str_autoDepositCode][0]);
                            }
                            break;
                        case 2:
                            this.dd_adty.push(constAutoDepositType[1]);

                            if (this.str_autoDepositCode != "" && this.str_autoDepositCode in constAutoDepositBankApp) {
                                this.dd_adty.push(constAutoDepositBankApp[this.str_autoDepositCode][1]);
                            }
                            break;
                        case 3:

                            if (this.str_autoDepositCode != "" && this.str_autoDepositCode in constAutoDepositBankApp) {
                                this.dd_adty.push(constAutoDepositBankApp[this.str_autoDepositCode][0]);
                                this.dd_adty.push(constAutoDepositBankApp[this.str_autoDepositCode][1]);
                            }
                            else {
                                this.dd_adty.push(constAutoDepositType[0]);
                                this.dd_adty.push(constAutoDepositType[1]);
                            }
                            break;
                        case 4:
                            this.dd_adty.push(constAutoDepositType[0]);

                            if (this.str_autoDepositCode != "" && this.str_autoDepositCode in constAutoDepositBankApp) {
                                this.dd_adty.push(constAutoDepositBankApp[this.str_autoDepositCode][0]);
                            }
                            break;
                    }
                }
                else
                    this.bool_isAutoDepositBank = 0;
            },

            isAutoDepositChange(value) {
                if (this.bool_obj_isAutoDeposit == 0 && value != 0) {
                    this.showSuccessMessage(this.getLanguage["BANK"]["AD"], this.getLanguage["BANK"]["ADAM"]);
                }
                this.obj_bankacc.PM = [];
                this.bool_obj_isAutoDeposit = value !== undefined ? value : 0;
                this.generateDepositType(this.bool_obj_isAutoDeposit);
            },
            clearPLURL() {
                if (!this.obj_bankacc.AGIT || !this.obj_bankacc.CC || !this.obj_bankacc.BI) {

                    this.obj_bankacc.PLURL = '';
                    this.bool_isDisablePLURL = true;
                } else
                {
                    this.bool_isDisablePLURL = false;
                }
            },
            getIURLTabIndex() {
                var result = 0;
                try {
                    var x = document.querySelector('#imageURLTab .nav.nav-tabs li a.active').innerText;
                    if (x == "Upload Image") {
                        result = 1;
                        return result;
                    }
                    else if (x === undefined) {
                        return result;
                    }
                    else {
                        result = 2;
                        return result;
                    }
                }
                catch (ex) {
                    console.log(ex);
                }
                return result;
            },
            onFileSelected(event) {
                this.obj_bankacc['QRCI'] = null;
                this.selectedFile = this.validateFile(event);
                this.newImg = true;
            },
            //getAutoDeposit(autoDepositType) {
            //    if (autoDepositType == 1)
            //        return '<i class="cib-automatic sortlogo text-orange" ></i>';
            //    else if (autoDepositType == 2)
            //        return '<i class="cib-automatic sortlogo text-orange" ></i><sup style="font-weight:bold;font-size:14px;margin-left:-3px;">+</sup>';
            //    else if (autoDepositType == 3)
            //        return '<i class="cib-automatic sortlogo text-orange" ></i><i class="cib-automatic sortlogo text-red" ></i><sup style="font-weight:bold;font-size:14px;margin-left:-3px;">+</sup>';
            //    else
            //        return "";
            //},
            getAutoDeposit(isAuto) {
                if (isAuto == 1 || isAuto == 11)
                    return '<i class="cib-automatic sortlogo text-orange" ></i>';
                else if (isAuto == 2 || isAuto == 12)
                    return '<i class="cib-automatic sortlogo text-orange" ></i><sup style="font-weight:bold;font-size:14px;margin-left:-3px;">+</sup>';
                else
                    return "";
            },
            setPreview(value) {
                this.previewUrl = value;
                this.bool_fullPreview = true;
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            renderClassName(header, data) {
                if (header == 'BL' || header == 'MIDPT' || header == 'MXDPT' || header == 'TDL' || header == 'ADA' || header == 'MIWPT' || header == 'MXWPT' || header == 'MXWPD') {
                    return "tableCtnRight";
                }
            },
            resetColumn(headerName) {
                var that = this;
                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            generateDepositType(value) {
                if (value == 0) {
                    this.dd_pm = [
                        { id: 1, label: this.getLanguage['MTA']['DPM1'] },
                        { id: 4, label: this.getLanguage['MTA']['DPM4'] },
                        { id: 10, label: this.getLanguage['MTA']['DPM10'] },
                        { id: 11, label: this.getLanguage['MTA']['DPM11'] },
                        { id: 40, label: this.getLanguage['MTA']['DPM40'] }
                    ];
                } else if (value == 1)
                    this.dd_pm = [
                        { id: 5, label: this.getLanguage['MTA']['DPM5'] }
                    ];
                else
                    this.dd_pm = [];
            },
            getVIP() {
                this.arry_vip = [{ id: "", label: this.getLanguage['GL']['ALL2'] }, { id: "1", label: this.getLanguage['PM']['YES'] }, { id: "2", label: this.getLanguage['PM']['NO'] }];
            },
            getStatus() {
                this.arry_status = [{ id: "1", label: this.getLanguage['GL']['IAC'] }, { id: "2", label: this.getLanguage['GL']['AC'] }];
            },
            getAccType() {
                this.arry_accType = [{ id: "0", label: this.getLanguage['BB']['W'] }, { id: "1", label: this.getLanguage['BB']['D'] }, { id: "2", label: this.getLanguage['BB']['DW'] }];
            },
            switchCurrencySymbol() {
                var oldFrom = this.obj_bankacc['FCS'];
                var oldTo = this.obj_bankacc['TCS'];

                this.obj_bankacc.ER = 1;
                this.obj_bankacc.TER = 1;
                this.obj_bankacc['FCS'] = oldTo;
                this.obj_bankacc['TCS'] = oldFrom;
            },
            disabledPointer() {
                return (!this.checkModuleAccess2(constAccessType.edit)) ? "cursor:not-allowed; filter:none" : "";
            },
        },
        watch: {
            'obj_bankacc.AT'(newValue) {
                if (this.obj_bankacc.I == 0) {
                    if (newValue == "0") { //with
                        this.bool_isW = true;
                        this.bool_isD = false;
                        this.obj_bankacc.MIND = null
                        this.obj_bankacc.MAXD = null
                        // this.obj_bankacc.TD = 0
                        this.obj_bankacc.ID = 0
                        this.obj_bankacc.IW = 1
                    } else if (newValue == "1") { // deposit
                        this.bool_isW = false;
                        this.bool_isD = true;
                        this.obj_bankacc.MINW = null
                        this.obj_bankacc.MAXW = null
                        this.obj_bankacc.TW = null
                        this.obj_bankacc.ID = 1
                        this.obj_bankacc.IW = null
                    } else if (newValue == "2") {
                        this.bool_isW = true;
                        this.bool_isD = true;
                        this.obj_bankacc.MINW = null
                        this.obj_bankacc.MAXW = null
                        this.obj_bankacc.TW = null
                        this.obj_bankacc.MIND = null
                        this.obj_bankacc.MAXD = null
                        // this.obj_bankacc.TD = 0
                        this.obj_bankacc.IW = 1
                        this.obj_bankacc.ID = 1
                    }
                }
                else {
                    if (newValue == "0") { //with
                        this.bool_isW = true;
                        this.bool_isD = false;

                        // this.obj_bankacc.TD = 0
                        this.obj_bankacc.ID = 0
                        this.obj_bankacc.IW = 1
                    } else if (newValue == "1") { // deposit
                        this.bool_isW = false;
                        this.bool_isD = true;
                        this.obj_bankacc.ID = 1
                    } else if (newValue == "2") {
                        this.bool_isW = true;
                        this.bool_isD = true;

                        // this.obj_bankacc.TD = 0
                        this.obj_bankacc.IW = 1
                        this.obj_bankacc.ID = 1
                    }
                }
            },
            'obj_bankacc.AGIT'(newValue) {
                this.clearPLURL();
            },
            'obj_bankacc.CC'(newValue) {
                this.clearPLURL();
            },
            'obj_bankacc.BI'(newValue) {
                this.clearPLURL();
            },
            bool_isSort(newValue) {
                this.getBankAccountList();
            },
            bool_obj_bankaccRS(newValue) {
                if (newValue == true) {
                    this.obj_bankacc["RS"] = "2"
                } else {
                    this.obj_bankacc["RS"] = "1"
                }
            },
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            bool_obj_isAutoDeposit(newValue) {
            },
            int_obj_autoDepositAppStep(newValue) {

            },
            int_obj_autoDepositWithdrawStep(newValue) {

            },
            bool_showSCBPassportCountry(newValue) { },
            getLanguage() {
                this.getBankAccountList();
                this.getVIP();
                this.getStatus();
                this.getAccType();
            },
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/AccountList`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }
                                // hide columns for unauthorized access users
                                if (!(that.checkModuleAccess2(constAccessType.edit) || that.checkModuleAccess2(constAccessType.delete))) {
                                    that.removeDefaultColumn('ACT')
                                    that.removeColumn('ACT')
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/AccountList/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            }
        },
        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'B';
            this.$parent.showActiveMenu = 'B.ACL';
            if (this.$route.query.agi) {
                this.str_FV[11].FV = this.$route.query.agi;
            }
            this.str_FV[1].FV = this.$route.query.ci;
            this.getBankAccountList();
            this.getDropdownList();
            this.getCountryCode();
            this.getCurrencyList();
            this.setThousandCurrency(false);
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
            this.generateDepositType(0);
            this.getVIP();
            this.getStatus();
            this.getAccType();

            //$(".custom_tooltip").hover(
            //function () {
            //    $(".table-wrapper .custom-table-wrapper").css("overflow" , "initial");
            //}, function() {
            //    (".table-wrapper .custom-table-wrapper").css({ "overflow": "auto", "overflow-y": "hidden" });
            //});
        },
    }
</script>




// WEBPACK FOOTER //
// src/components/SideMenu/Banks/AccountList.vue